import { type } from "os";
export default class Ott {
    constructor($scope,
        $routeParams,
        method,
        ottService,
        incidenciaService,
        inventarioService,
        protocolosService,
        tareasService,
        herramientasService,
        prioridadesService,
        proyectosService,
        objetoUbicacionService,
        ubicacionService,
        baseUrl,
        alertasService,
        columnasService,
        tipoUbicacionesService,
        riesgoService,
        $location,
        $uibModal,
        tipoFallaService,
        causaFallaService,
        estadosService,
        CalendarioService,
        EquiposTecnicos,
        Disponibilidad,
        $q,
        periodosService,
        vehiculoService,
        clientesService,
        toastr,
        $route,
        info,
        tipoEquipoService,
        Upload,
        filtros,
        problemaCorrectivoService,
        causaFallaCorrectivaService,
        nivelIncidenciaService,
        $timeout,
        $window) {

        this.baseUrl = baseUrl;
        this.scope = $scope;
        this.modal = $uibModal;
        this.uibModal = $uibModal;
        this.location = $location;
        this.toastr = toastr;
        this.route = $route;
        this.scope.info = info;
        this.scope.handleDisplayFilters = this.handleDisplayFilters.bind(this);
        this.scope.displayFilters = false;
        this.scope.method = method;
        this.ottser = ottService;
        var self = this;

        this.scope.cliente = localStorage.getItem('cliente')
        this.scope.columnas = columnasService.getColumnasOtt(this.scope.cliente);

        this.scope.$watch("info.get('permisos')", function (newVal) {
            if (angular.isDefined(newVal.ot)) {
                self.scope.readOnly = !newVal.ot.w;
                self.scope.canDelete = newVal.ot.d;
            }
        });

        this.scope.$watch("info.get('flag_tecnico')", function (newVal) {
            if (angular.isDefined(newVal)) {
                self.scope.isTecnico = newVal;
            }
        });

        this.scope.$watch("info.get('flag_correo')", function (newVal) {
            if (angular.isDefined(newVal)) {
                self.scope.isCorreo = newVal;
            }
        });

        switch (method) {
            case 'list':
                this.scope.nombre = "Ordenes de Trabajo Reactivas";

                let filter_ = {
                    "estado.grupo": 'ott',
                    "estado.index": {
                        $ne: 1
                    }
                };

                this.list(ottService,
                    clientesService,
                    proyectosService,
                    estadosService,
                    prioridadesService,
                    columnasService,
                    filter_,
                    info,
                    filtros,
                    $timeout,
                    $window
                );

                this.scope.descargarExcel = this.descargarExcel.bind(this);
                break;
            case 'view':
                this.view(ottService,
                    $routeParams,
                    prioridadesService,
                    alertasService,
                    tipoUbicacionesService,
                    ubicacionService,
                    inventarioService,
                    riesgoService,
                    tipoFallaService,
                    causaFallaService,
                    objetoUbicacionService,
                    tareasService,
                    herramientasService,
                    estadosService,
                    vehiculoService,
                    toastr,
                    EquiposTecnicos,
                    info,
                    Upload,
                    causaFallaCorrectivaService
                );
                break;
            case 'new':
                this.create(ottService,
                    $routeParams,
                    incidenciaService,
                    inventarioService,
                    protocolosService,
                    tareasService,
                    herramientasService,
                    prioridadesService,
                    proyectosService,
                    objetoUbicacionService,
                    ubicacionService,
                    tipoUbicacionesService,
                    CalendarioService,
                    EquiposTecnicos,
                    Disponibilidad,
                    $q,
                    periodosService,
                    vehiculoService,
                    tipoEquipoService,
                    info,
                    problemaCorrectivoService,
                    nivelIncidenciaService);
                break;

            case 'por_agendar':
                this.scope.nombre = "Ordenes de Trabajo Preventivas";

                let filter = {
                    "estado.grupo": 'ott',
                    "estado.index": 1,
                    // "preventiva": true
                };

                this.list(ottService,
                    clientesService,
                    proyectosService,
                    estadosService,
                    prioridadesService,
                    columnasService,
                    filter,
                    info,
                    filtros);
                this.scope.descargarExcel = this.descargarExcel.bind(this);
                break;

            case 'por_agendar_view':

                this.view_por_agendar(ottService,
                    $routeParams,
                    prioridadesService,
                    tareasService,
                    riesgoService,
                    herramientasService,
                    CalendarioService,
                    EquiposTecnicos,
                    Disponibilidad,
                    $q,
                    estadosService,
                    info,
                    vehiculoService);
                break;

            case 'completar_list':
                this.scope.nombre = "Ordenes de Trabajo Reactivas";

                let filter__ = {
                    "estado.grupo": 'ott',
                    "estado.index": 2
                };

                this.list(ottService, filter__);

                this.scope.descargarExcel = this.descargarExcel.bind(this);
                break;

            case 'completar_view':
                this.view(ottService,
                    $routeParams,
                    prioridadesService,
                    alertasService,
                    tipoUbicacionesService,
                    ubicacionService,
                    inventarioService,
                    riesgoService,
                    tipoFallaService,
                    causaFallaService,
                    objetoUbicacionService,
                    tareasService,
                    herramientasService,
                    estadosService,
                    info);
                break;
            case 'pdfFilter':
                this.scope.nombre = "Ordenes de Trabajo";

                let filter_pdf = {
                    "estado.grupo": 'ott',
                    "estado.index": {
                        $ne: 1
                    },
                    "page": 1,
                    "limit": 10
                };

                this.filterPDF(ottService,
                    clientesService,
                    proyectosService,
                    estadosService,
                    prioridadesService,
                    columnasService,
                    filter_pdf
                );

                this.scope.descargarPdfLapizMasivo = this.descargarPdfLapizMasivo.bind(this);

                break;
            case 'carga':
                this.carga(Upload);
                break;
        }
    }

    list(ottService, clientesService, proyectosService, estadosService, prioridadesService, columnasService, filter, info, filtros, $timeout, $window) {


        var self = this.scope;
        this.scope.nombre = "Ordenes de Trabajo";
        this.scope.descargarExcel = this.descargarExcel.bind(this);
        this.scope.calcularAvance = this.calcularAvance.bind(this);
        this.scope.getUbicacion = this.getUbicacion.bind(this);
        this.scope.getUbicacionAvo = this.getUbicacionAvo.bind(this);
        this.scope.getTipo = this.getTipo.bind(this);
        this.scope.currentPage = 1;
        this.scope.totalItems = 0;
        self.showColumnAvance = true;
        self.showColumnEquipo = true;
        self.showColumnGlpi = false;
        self.makingSearch = false;
        this.scope.aux = {
            cliente: {},
            clientes: [],
            proyecto: {},
            proyectos: []
        };
        // console.log(self.columnas)
        self.filtros = filtros.ott;

        this.scope.userProyects = info.get('proyectos');

        if (typeof self.filtros.desde === 'undefined') {
            self.filtros.desde = moment().startOf('month').format('DD-MM-YYYY');
            self.filtros.desdeM = moment().startOf('month');
        }

        let preventiva = filter.preventiva;

        this.scope.showOtt = (orden) => {
            $window.open(`/#!/ott/${orden._id}`, '_blank');
        };
        this.scope.showOttPorAgendar = (orden) => {
            this.location.path('/ott/por_agendar/' + orden._id);
        };

        clientesService.getAll()
            .then((resp) => {
                console.log(resp)
                let data = resp.data.message.map((el) => {
                    el.nombre_interno = "proyecto.cliente._id";
                    return el;
                });
                this.scope.aux.clientes = data;
                console.log(this.scope.aux.clientes)
            });

        this.scope.$watch('filtros.cliente', (nuevo) => {

            if (nuevo) {
                let filter = {
                    "cliente._id": nuevo._id
                };
                filter = JSON.stringify(filter);
                proyectosService.getAll({ string: filter })
                    .then((resp) => {
                        console.log(resp)
                        let data = resp.data.message.map((el) => {
                            el.nombre_interno = "proyecto";
                            return el;
                        });
                        this.scope.aux.proyectos = data;
                        this.scope.columnas = columnasService.getColumnasOtt(nuevo.abreviacion);
                        console.log(this.scope.columnas)
                    });
            } else {
                this.scope.aux.proyectos = [];
            }
        });

        this.scope.$watch('filtros.proyecto', (nuevo) => {

            if (nuevo) {
                let filter = {
                    grupo: 'ott',
                    proyecto: nuevo._id,
                };

                estadosService.getAll(filter)
                    .then((resp) => {
                        let data = resp.data.message.map((el) => {
                            el.nombre_interno = "estado._id";
                            return el;
                        });
                        data = data.filter(estado => {
                            return estado.index != 1;
                        })
                        this.scope.aux.estados = data;
                        // console.log(this.scope.aux.estados)
                    });
            } else {
                // this.scope.aux.proyectos = [];
            }
        });



        prioridadesService.getAll()
            .then((resp) => {
                let data = resp.data.message.map((el) => {
                    el.nombre_interno = "prioridad._id";
                    return el;
                });
                this.scope.aux.prioridades = data;
            });

        if (preventiva) {
            this.scope.aux = {
                filtros: {
                    preventiva: true,
                    "estado.index": 1
                }
            };
        } else {
            this.scope.aux = {
                filtros: {
                    "estado.index": {
                        $ne: 1
                    }
                }
            };
        }

        var ar_watch = ['filtros.cliente', 'filtros.proyecto', 'filtros.estado', 'filtros.prioridad', 'filtros.tipo', 'filtros.desde', 'filtros.hasta'];

        this.scope.$watchGroup(ar_watch, (nuevo) => {

            let filtro = {};

            if (preventiva) {
                filtro["preventiva"] = true;
                filtro["estado.index"] = 1;
            } else {
                filtro["estado.index"] = {
                    $ne: 1
                };
            }

            // Si es la vista 'por agendar' busco las preventivas con estado de indice 1 y sin restriccion de fecha
            if (this.scope.method == "por_agendar") {
                filtro["preventiva"] = false;
                filtro["estado.index"] = 1;
            }
            //-----------------------------------------------------------------------------------------------------
            let ok = false;
            for (var k in nuevo) {
                let x = nuevo[k];
                if (x || ok) {
                    ok = true;
                }
            }
            if (!ok) {
                // filtro = JSON.stringify(filtro);
                filtro.page = this.scope.currentPage;
                filtro.limit = 10;
                self.filtros = filtro;
                ottService.getAll(filtro).then((resp, err) => {
                    if (!err) {
                        this.scope.otts = [];
                        this.scope.otts = resp.data.message.docs;
                        this.scope.currentPage = resp.data.message.page;
                        this.scope.totalItems = resp.data.message.total;
                        this.scope.otts.forEach(function (orden) {
                            if (typeof orden.proyecto.no_requeridos !== 'undefined' &&
                                typeof orden.proyecto.no_requeridos.ott !== 'undefined') {
                                if (orden.proyecto.no_requeridos.ott.indexOf('avance') > -1) {
                                    self.showColumnAvance = false;
                                }
                                if (orden.proyecto.no_requeridos.ott.indexOf('equipo') > -1) {
                                    self.showColumnEquipo = false;
                                }
                                if (orden.proyecto.cliente.abreviacion.toString() == "ACSA") {
                                    self.showColumnGlpi = true;
                                }
                            }
                        });
                        self.makingSearch = false;
                    }
                });
                return false;
            }
            for (var el in nuevo) {
                let element = nuevo[el];

                // console.log(el, nuevo[el]);
                if (element) {
                    if (element._id) {
                        filtro[element.nombre_interno] = element._id;
                    } else if (element === 'correctiva') {
                        filtro['preventiva'] = true;
                    } else if (element === 'preventiva') {
                        filtro['preventiva'] = false;
                    } else {
                        if (el == 5 && typeof nuevo[6] === 'undefined') {
                            var timezone = self.filtros.desdeM._d.getTimezoneOffset();
                            var DateFromMili = moment(self.filtros.desdeM._d.getTime() - (timezone * 60 * 1000));
                            filtro['fecha_agendada'] = { "$gte": DateFromMili }
                        } else if (el == 6 && typeof nuevo[5] === 'undefined') {
                            var timezone = self.filtros.hastaM._d.getTimezoneOffset();
                            var DateFromMili = moment((self.filtros.hastaM._d.getTime() + 86400000) - (timezone * 60 * 1000));
                            filtro['fecha_agendada'] = { "$lt": DateFromMili }
                        } else if (el == 5 && typeof nuevo[6] !== 'undefined') {
                            var timezone = self.filtros.desdeM._d.getTimezoneOffset();
                            var DateFromMiliG = moment(self.filtros.desdeM._d.getTime() - (timezone * 60 * 1000));
                            var DateFromMiliL = moment((self.filtros.hastaM._d.getTime() + 86400000) - (timezone * 60 * 1000));
                            filtro['fecha_agendada'] = { "$gte": DateFromMiliG, "$lt": DateFromMiliL }
                        } else {
                            filtro[element.tipo_p] = element.valor;
                        }
                    }
                }
            }

            //-------------------------------SI es por agendar quito restriccion de fecha

            if (this.scope.method == "por_agendar") {
                delete filtro.fecha_agendada
            }

            //----------------------
            this.scope.aux.query = filtro;

            if (this.scope.filtros.searchKeyword !== '') {
                filtro['searchKeyword'] = this.scope.filtros.searchKeyword;
            }

            // filtro = JSON.stringify(filtro);
            filtro.page = self.filtros.page;
            ottService.getAll(filtro)
                .then((resp, err) => {
                    if (!err) {
                        this.scope.otts = resp.data.message.docs;
                        console.log(this.scope.otts)
                        this.scope.currentPage = resp.data.message.page;
                        this.scope.totalItems = resp.data.message.total;
                        if (this.scope.otts) {
                            this.scope.otts.forEach(function (orden) {
                                if (typeof orden.proyecto.no_requeridos !== 'undefined' &&
                                    typeof orden.proyecto.no_requeridos.ott !== 'undefined') {
                                    if (orden.proyecto.no_requeridos.ott.indexOf('avance') > -1) {
                                        self.showColumnAvance = false;
                                    }
                                    if (orden.proyecto.no_requeridos.ott.indexOf('equipo') > -1) {
                                        self.showColumnEquipo = false;
                                    }
                                    if (orden.proyecto.cliente.abreviacion.toString() == "ACSA") {
                                        self.showColumnGlpi = true;
                                    }
                                }
                                self.makingSearch = false;
                            });
                        }
                    } else {
                        console.log(err);
                        self.makingSearch = false;
                    }
                });
        });

        self.limpiarFiltros = () => {
            self.filtros.desde = null;
            self.filtros.desdeM = null;
            self.filtros.hasta = null;
            self.filtros.hastaM = null;
            self.filtros.cliente = null;
            self.filtros.proyecto = null;
            self.filtros.estado = null;
            self.filtros.prioridad = null;
            self.filtros.tipo = "";
            self.filtros.searchKeyword = "";
        };

        self.changePage = (newPageNumber, oldPageNumber) => {
            // if (!self.makingSearch) {
            let filtro = this.scope.aux.query;
            filtro.page = newPageNumber;
            filtro.limit = 10;
            self.filtros.page = newPageNumber;
            ottService.getAll(filtro)
                .then((resp, err) => {
                    if (!err) {
                        this.scope.otts = [];
                        this.scope.totalItems = resp.data.message.total;
                        this.scope.currentPage = resp.data.message.page;
                        this.scope.otts = resp.data.message.docs;
                        this.scope.otts.forEach(function (orden) {
                            if (typeof orden.proyecto.no_requeridos !== 'undefined' &&
                                typeof orden.proyecto.no_requeridos.ott !== 'undefined') {
                                if (orden.proyecto.no_requeridos.ott.indexOf('avance') > -1) {
                                    self.showColumnAvance = false;
                                }
                                if (orden.proyecto.no_requeridos.ott.indexOf('equipo') > -1) {
                                    self.showColumnEquipo = false;
                                }
                                if (orden.proyecto.cliente.abreviacion.toString() == "ACSA") {
                                    self.showColumnGlpi = true;
                                }
                            }
                            self.timer = false;
                        });
                    } else {
                        console.log(err);
                        self.timer = false;
                    }
                });
            // }
        }

        self.timer = false;
        self.filterBy = () => {
            if (!self.timer) {
                self.timer = true;
                // if (self.filtros.searchKeyword) {                    
                $timeout(() => {
                    self.makingSearch = true;
                    let filtro = {};

                    if (this.scope.aux.query.tipo === 'correctiva') {
                        filtro['preventiva'] = true;
                    } else if (this.scope.filtros.tipo === 'preventiva') {
                        filtro['preventiva'] = false;
                    }
                    if (typeof filtro['estado._id'] === 'undefined') {
                        filtro["estado.index"] = {
                            $ne: 1
                        };
                    }

                    if (this.scope.aux.query.prioridad) {
                        filtro["prioridad._id"] = this.scope.aux.query.prioridad._id;
                    }

                    if (this.scope.aux.query.estado) {
                        delete filtro['estado.index'];
                        filtro["estado._id"] = this.scope.aux.query.estado._id;
                    }

                    if (this.scope.aux.query.cliente) {
                        filtro["proyecto.cliente._id"] = this.scope.aux.query.cliente._id;
                    }

                    if (this.scope.aux.query.proyecto) {
                        filtro["proyecto"] = this.scope.aux.query.proyecto._id;
                    }

                    if (typeof filtro['proyecto'] !== 'undefined') {
                        delete filtro['proyecto.cliente._id'];
                    }

                    if (this.scope.filtros.desdeM !== undefined && this.scope.filtros.hastaM === undefined) {
                        var timezone = this.scope.filtros.desdeM._d.getTimezoneOffset();
                        var DateFromMili = moment(this.scope.filtros.desdeM._d.getTime() - (timezone * 60 * 1000));
                        filtro['fecha_agendada'] = { "$gte": DateFromMili }
                    } else if (this.scope.filtros.hastaM !== undefined && this.scope.filtros.desdeM === undefined) {
                        var timezone = this.scope.filtros.hastaM._d.getTimezoneOffset();
                        var DateFromMili = moment((this.scope.filtros.hastaM._d.getTime() + 86400000) - (timezone * 60 * 1000));
                        filtro['fecha_agendada'] = { "$lt": DateFromMili }
                    } else if (this.scope.filtros.desdeM !== undefined && this.scope.filtros.hastaM !== undefined) {
                        var timezone = this.scope.filtros.desdeM._d.getTimezoneOffset();
                        var DateFromMiliG = moment(this.scope.filtros.desdeM._d.getTime() - (timezone * 60 * 1000));
                        var DateFromMiliL = moment((this.scope.filtros.hastaM._d.getTime() + 86400000) - (timezone * 60 * 1000));
                        filtro['fecha_agendada'] = { "$gte": DateFromMiliG, "$lt": DateFromMiliL }
                    }

                    if (this.scope.filtros.searchKeyword !== '') {
                        filtro['searchKeyword'] = this.scope.filtros.searchKeyword;
                    }

                    this.scope.aux.query = filtro;
                    // filtro.page = this.scope.currentPage;
                    // filtro.limit = 10;
                    ottService.getAll(filtro)
                        .then((resp, err) => {
                            if (!err) {
                                this.scope.otts = [];
                                this.scope.totalItems = resp.data.message.total;
                                this.scope.currentPage = resp.data.message.page;
                                this.scope.otts = resp.data.message.docs;
                                this.scope.otts.forEach(function (orden) {
                                    if (typeof orden.proyecto.no_requeridos !== 'undefined' &&
                                        typeof orden.proyecto.no_requeridos.ott !== 'undefined') {
                                        if (orden.proyecto.no_requeridos.ott.indexOf('avance') > -1) {
                                            self.showColumnAvance = false;
                                        }
                                        if (orden.proyecto.no_requeridos.ott.indexOf('equipo') > -1) {
                                            self.showColumnEquipo = false;
                                        }
                                        if (orden.proyecto.cliente.abreviacion.toString() == "ACSA") {
                                            self.showColumnGlpi = true;
                                        }
                                    }
                                });
                                self.timer = false;
                            } else {
                                console.log(err);
                                self.timer = false;
                                self.makingSearch = false;
                            }
                        });
                }, 1600);
                // } else {
                //     self.timer = false;
                //     self.makingSearch = false;
                // }              
            }
        }

        self.orderBy = (sortType) => {
            self.sortType = sortType;
            self.sortReverse = !self.sortReverse;
            let filtro = this.scope.aux.query;
            filtro.sort = {};
            filtro.sort[self.sortType] = (self.sortReverse) ? 1 : -1;
            this.scope.aux.query = filtro;
            ottService.getAll(filtro)
                .then((resp, err) => {
                    if (!err) {
                        this.scope.otts = [];
                        this.scope.totalItems = resp.data.message.total;
                        this.scope.currentPage = resp.data.message.page;
                        this.scope.otts = resp.data.message.docs;
                        this.scope.otts.forEach(function (orden) {
                            if (typeof orden.proyecto.no_requeridos !== 'undefined' &&
                                typeof orden.proyecto.no_requeridos.ott !== 'undefined') {
                                if (orden.proyecto.no_requeridos.ott.indexOf('avance') > -1) {
                                    self.showColumnAvance = false;
                                }
                                if (orden.proyecto.no_requeridos.ott.indexOf('equipo') > -1) {
                                    self.showColumnEquipo = false;
                                }
                                if (orden.proyecto.cliente.abreviacion.toString() == "ACSA") {
                                    self.showColumnGlpi = true;
                                }
                            }
                        });
                    } else {
                        console.log(err);
                    }
                });
        }
    }

    view(ottService,
        $routeParams,
        prioridadesService,
        alertasService,
        tipoUbicacionesService,
        ubicacionService,
        inventarioService,
        riesgoService,
        tipoFallaService,
        causaFallaService,
        objetoUbicacionService,
        tareasService,
        herramientasService,
        estadosService,
        vehiculoService,
        toastr,
        EquiposTecnicos,
        info,
        Upload,
        causaFallaCorrectivaService) {
        var self = this.scope;
        self.inAction = false;
        self.btn_update = false;
        this.scope.getUbicacion = this.getUbicacion.bind(this);
        this.scope.aux = {
            nueva_observacion: '',
            avance: {},
            prioridad: {}
        };

        prioridadesService.getAll()
            .then((resp) => {
                this.scope.prioridades = resp.data.message;
            });

        alertasService.getAll().then((resp, err) => {
            this.scope.alertas = resp.data.message;
        });

        riesgoService.getAll()
            .then((resp) => {
                this.scope.riesgos = resp.data.message;
            });

        ottService.getById({ _id: $routeParams.id }).then((resp) => {
            self.ott = resp.data.message;
            self.ott.imagenes = resp.data.imagenes;
            self.ott.calendario = resp.data.calendario;
            self.ott.textFiles = resp.data.archivos;

            if (self.ott.fecha_agendada) {
                if (this.scope.esRequerido('agenda', 'ott')) {
                    self.ott.fecha_agendada = moment(self.ott.fecha_agendada).format('DD-MM-YYYY HH:mm');
                } else {
                    self.ott.fecha_agendada = moment(self.ott.fecha_agendada).format('DD-MM-YYYY');
                }
            }

            if (self.ott.protocolo[0].fecha_inicio) {
                self.ott.protocolo[0].fecha_inicio = moment(self.ott.protocolo[0].fecha_inicio).format('DD-MM-YYYY HH:mm');
            }

            if (self.ott.protocolo[0].fecha_fin) {
                self.ott.protocolo[0].fecha_fin = moment(self.ott.protocolo[0].fecha_fin).format('DD-MM-YYYY HH:mm');
            }

            if (typeof self.ott.proyecto.configuracion !== 'undefined' &&
                typeof self.ott.proyecto.configuracion.ott !== 'undefined' &&
                typeof self.ott.proyecto.configuracion.ott.tareas !== 'undefined' &&
                typeof self.ott.proyecto.configuracion.ott.tareas.acordeon !== 'undefined' &&
                self.ott.proyecto.configuracion.ott.tareas.acordeon === false) {

                estadosService.getAll({ "grupo": 'tarea_list' })
                    .then((resp) => {
                        self.estadosTareas = resp.data.message;
                    });
            } else {

                estadosService.getAll({ "grupo": 'tarea' })
                    .then((resp) => {
                        self.estadosTareas = resp.data.message;
                    });
            }
            self.aux.avance = this.calcularAvance(this.scope.ott);
            self.aux.prioridad = self.ott.prioridad[0];
            self.aux.vehiculos = [self.ott.vehiculo];

            for (var key in self.ott.ubicacion) {
                if (self.ott.ubicacion.hasOwnProperty(key)) {
                    this.scope.descripcionUbicacion = self.ott.ubicacion[key].descripcion;
                }
            }

            let filterP2 = {
                proyecto: self.ott.proyecto._id
            }
            EquiposTecnicos.getAll(filterP2).then((val) => {
                this.scope.aux.teams = val.data;
            });

            let wat = function () {
                return self.aux.prioridad;
            };
            this.scope.$watch(wat, function (nuevo, viejo) {
                if (angular.equals(viejo, nuevo)) return false;
                self.btn_update = true;
            }, true);

            ottService.movementsByLocation({ location: self.ott.ubicacion.tramo.nombre, project: self.ott.proyecto.nombre }).then((movimientos) => {
                self.movimientos = movimientos.data.message.message;
            }, (error) => {
                console.log(error);
            })
        }).catch((er) => {
            console.log(er);
        });

        self.agregarObservacion = () => {

            if (!this.scope.aux.nueva_observacion || 0 === this.scope.aux.nueva_observacion.length) {
                this.toastr.warning('Debe ingresar una observación!', 'Warning!', {
                    timeOut: 2000,
                    closeButton: true
                });
                return;
            }
            if (!self.inAction) {
                self.inAction = true;
                let observacion = {
                    text: this.scope.aux.nueva_observacion,
                    usuario: info.get('nombre') + ' ' + info.get('apellido'),
                    fecha: new Date(),
                    "ott": {
                        "_id": self.ott._id
                    }
                };

                ottService.agregarObservacion(observacion)
                    .then((resp) => {
                        self.inAction = false;
                        if (this.scope.ott.observaciones == undefined) {
                            this.scope.ott.observaciones = [];
                        }
                        this.scope.ott.observaciones.push(observacion);
                        this.scope.aux.nueva_observacion = '';

                        this.toastr.success('Observacion creada correctamente!', 'Success!', {
                            timeOut: 2000,
                            closeButton: true
                        });
                    });
            }

        };

        self.guardar = () => {
            let data = this.scope.ott;
            data.prioridad = [this.scope.aux.prioridad];
            ottService.update(data)
                .then((resp) => {
                    this.location.path('/ott');
                });
        }; 0


        self.aux = {};

        self.upFile = ($files) => {
            if ($files.length > 10) return false;
            self.files = $files;
        };

        self.imageUpload = () => {
            if (!self.files || self.ott.imagenes.length == 10) return false;
            Upload.upload({
                url: this.baseUrl + '/api/ott/subirimagen',
                data: {
                    _id: self.ott._id,
                    filess: self.files
                },
                filess: self.files
            }).then((res, err) => {
                if (res.data.success == 'ok') {
                    self.ott.imagenes = res.data.imageList;
                    this.toastr.success('Archivo agregado correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                } else {
                    this.toastr.error(res.data.message, 'Error!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                }
            });
        };

        self.upFileText = ($files) => {
            // if($files.length > 10) return false;
            self.textFiles = $files;
        };

        self.fileUpload = () => {
            if (!self.textFiles) return false;
            Upload.upload({
                url: this.baseUrl + '/api/ott/subirArchivo',
                data: {
                    _id: self.ott._id,
                    filess: self.textFiles
                },
                filess: self.textFiles
            }).then((res, err) => {
                if (res.data.success == 'ok') {
                    self.ott.textFiles = res.data.fileList;
                    this.toastr.success('Archivo agregado correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                } else {
                    this.toastr.error(res.data.message, 'Error!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                }
            });
        };

        this.scope.esRequerido = (element, tab) => {
            let result = true;
            if (typeof this.scope.ott !== 'undefined' && this.scope.ott != null) {
                let proyecto = this.scope.ott.proyecto;
                if (typeof proyecto !== "undefined" && proyecto != null) {
                    if (typeof proyecto.no_requeridos !== "undefined" && proyecto.no_requeridos != null) {
                        if (typeof proyecto.no_requeridos[tab] !== "undefined" && proyecto.no_requeridos[tab] != null) {
                            result = proyecto.no_requeridos[tab].indexOf(element) == -1;
                        }
                    }
                }
            }
            return result;
        }
        self.aux.registrarFalla = this.registrarFalla.bind(this, ottService, tipoUbicacionesService, ubicacionService, inventarioService, tipoFallaService, causaFallaService);
        self.aux.registrarMovimiento = this.registrarMovimiento.bind(this, tipoUbicacionesService, ubicacionService, inventarioService, objetoUbicacionService, ottService, toastr);
        self.aux.agregarTarea = this.agregarTarea.bind(this, ottService, tareasService, herramientasService, riesgoService, toastr);
        self.aux.actualizarTarea = this.actualizarTarea.bind(this, ottService, info);
        self.aux.cerrarOtt = this.cerrarOtt.bind(this, ottService);
        self.aux.finalizarOtt = this.finalizarOtt.bind(this, ottService, info);
        self.aux.actualizarOtt = this.actualizarOtt.bind(self, ottService);
        self.aux.descargarPdf = this.descargarPdf.bind(this, ottService);
        self.aux.descargarPdfLapiz = this.descargarPdfLapiz.bind(this, ottService);
        self.aux.descargarImagen = this.descargarImagen.bind(this, ottService);
        self.aux.guardarTareas = this.guardarTareas.bind(this, toastr, ottService, info, causaFallaCorrectivaService);
        self.aux.descargarArchivo = this.descargarArchivo.bind(this, ottService);
        self.aux.reagendar = this.reagendar.bind(this, ottService, toastr);
        self.aux.eliminar = this.eliminar.bind(this, ottService);
        self.aux.eliminarImagen = this.eliminarImagen.bind(this, ottService, toastr);
        self.aux.eliminarDoc = this.eliminarDoc.bind(this, ottService, toastr);
    }

    descargarPdf(ottService) {

        let data = {
            _id: this.scope.ott._id
        }

        ottService.pdf(data)
            .then((resp) => {

                var url = window.location;
                var urlNew = this.baseUrl + '/api/ott/pdf/' + resp.data.nombre + '?token=' + localStorage.getItem('token');
                window.open(urlNew);
            });
    }

    descargarImagen(ottService, imageName) {

        var url = window.location;
        var urlNew = this.baseUrl + '/api/ott/imagen/' + this.scope.ott._id + '/' + imageName + '?token=' + localStorage.getItem('token');
        window.open(urlNew, '_blank', 'location=yes,height=570,width=520,scrollbars=yes,status=yes');
    }

    eliminarImagen(ottService, toastr, imageName) {

        var self = this.scope;
        let templateModal = `
			<div class="modal-content">
				<div class="modal-header">
					<h4 style="text-align:center;" class="modal-title">Eliminar Imagen</h4>
				</div>
				<div class="modal-body">
					<div class="form-horizontal form-label-left">
                        <div class="row">
                            <div class="col-md-12 col-sm-12">				
                                ¿Esta seguro que quiere eliminar la imagen {{ctr.imageName}}?
                            </div>
                            	        
                        </div>
					</div>
			    </div>
                <div class="modal-footer">
                    <div class="btn btn-success pull-left" data-dismiss="modal" ng-click="ctr.cancel()">Cancelar</div>
					<div class="btn btn-danger pull-right" ng-click="ctr.delete()">Eliminar</div>
			    </div>
			</div>
		`;
        let modal = this.modal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            template: templateModal,
            controller: function (ott) {
                var vm = this;
                vm.imageName = imageName;
                this.delete = () => {
                    let data = {
                        _id: ott._id,
                        imageName: vm.imageName
                    }
                    modal.close(data);
                }

                this.cancel = () => {
                    modal.close();
                }
            },
            controllerAs: 'ctr',
            size: 'sm',
            resolve: {
                ottService: function () {
                    return ottService;
                },
                ott: function () {
                    return self.ott;
                }
            }
        });

        modal.result.then((resp_in) => {

            if (resp_in) {
                ottService.eliminarImagen(resp_in)
                    .then((resp) => {
                        if (resp.data.success == 'ok') {
                            let index = 0;
                            self.ott.imagenes.forEach(function (image) {
                                index++;
                            });
                            self.ott.imagenes.splice(index, 1);
                        } else {
                            this.toastr.error("Error al eliminar imagen", 'Error!', {
                                timeOut: 2000,
                                closeButton: true
                            });
                        }

                    });
            }
        }, (exit) => {
            console.log('modal close');
        });
    }

    actualizarOtt(ottService) {
        this.prioridad = this.aux.prioridad;
        ottService.update(this.ott)
            .then((resp) => {
                self.btn_update = false;
            });
    }

    eliminarDoc(ottService, toastr, docName) {

        var self = this.scope;
        let templateModal = `
            <div class="modal-content">
                <div class="modal-header">
                    <h4 style="text-align:center;" class="modal-title">Eliminar Archivo</h4>
                </div>
                <div class="modal-body">
                    <div class="form-horizontal form-label-left">
                        <div class="row">
                            <div class="col-md-12 col-sm-12">               
                                ¿Esta seguro que quiere eliminar el archivo {{ctr.docName}}?
                            </div>
                                        
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="btn btn-success pull-left" data-dismiss="modal" ng-click="ctr.cancel()">Cancelar</div>
                    <div class="btn btn-danger pull-right" ng-click="ctr.delete()">Eliminar</div>
                </div>
            </div>
        `;
        let modal = this.modal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            template: templateModal,
            controller: function (ott) {
                var vm = this;
                vm.docName = docName;
                this.delete = () => {
                    let data = {
                        _id: ott._id,
                        docName: vm.docName
                    }
                    modal.close(data);
                }

                this.cancel = () => {
                    modal.close();
                }
            },
            controllerAs: 'ctr',
            size: 'sm',
            resolve: {
                ottService: function () {
                    return ottService;
                },
                ott: function () {
                    return self.ott;
                }
            }
        });

        modal.result.then((resp_in) => {

            if (resp_in) {
                ottService.eliminarArchivo(resp_in)
                    .then((resp) => {
                        if (resp.data.success == 'ok') {
                            let index = 0;
                            self.ott.textFiles.forEach(function (docName, ind) {
                                if (docName == resp.data.message) {
                                    index == ind;
                                }
                            });
                            self.ott.textFiles.splice(index, 1);
                        } else {
                            this.toastr.error("Error al eliminar archivo", 'Error!', {
                                timeOut: 2000,
                                closeButton: true
                            });
                        }

                    });
            }
        }, (exit) => {
            console.log('modal close');
        });
    }

    view_por_agendar(ottService,
        $routeParams,
        prioridadesService,
        tareasService,
        riesgoService,
        herramientasService,
        CalendarioService,
        EquiposTecnicos,
        Disponibilidad,
        $q,
        estadosService,
        info,
        vehiculoService) {

        var self = this.scope;
        var grand_self = this;
        this.scope.aux = {};
        self.cliente = localStorage.getItem('cliente');

        this.scope.getUbicacion = this.getUbicacion.bind(this);

        self.aux = {
            prioridad: {},
            dualist: {
                options: {
                    leftContainerLabel: 'Tareas Disponibles',
                    rightContainerLabel: 'Tareas Seleccionadas',
                    active: !self.readOnly
                },
                izquierda: [],
                derecha: [],
                removeVal: [],
                active: true
            },
            tools: {
                options: {
                    leftContainerLabel: 'Herramientas Disponibles',
                    rightContainerLabel: 'Herramientas Seleccionadas',
                    active: !self.readOnly
                },
                izquierda: [],
                derecha: [],
                removeVal: [],
                active: true
            },
            selects: {},
            ubicacion: {},
            index: 0
        };

        ottService.getById({ _id: $routeParams.id }).then((respOtt) => {
            self.ott = respOtt.data.message;
            self.ott.fecha_inicio = moment(self.ott.fecha_inicio).format('DD-MM-YYYY');
            self.aux.fecha_ott = self.ott.fecha_inicio;

            self.aux.selects = JSON.parse(JSON.stringify(self.ott.ubicacion));
            self.aux.ubicacion = JSON.parse(JSON.stringify(self.ott.ubicacion));

            for (var el in self.aux.selects) {
                self.aux.selects[el] = [self.aux.selects[el]]
            }

            self.aux.prioridades = self.ott.prioridad;
            self.aux.prioridad_modelo = self.ott.prioridad[0];
            self.aux.periodos = [self.ott.periodo]
            self.aux.proyectos = [self.ott.proyecto];

            let key;
            for (var el in self.ott.ubicacion) {
                key = el;
                break;
            }

            self.aux.objeto_ubicacion_modelo = self.ott.ubicacion[key].objeto_ubicacion;
            self.aux.objeto_ubicaciones = [self.ott.ubicacion[key].objeto_ubicacion];
            self.aux.prioridad = self.ott.prioridad;

            self.aux.tipo_ubicaciones = self.ott.ubicacion;
            self.aux.dualist.derecha = self.ott.protocolo[0].listado_tareas;


            tareasService.getAll()
                .then((resp) => {
                    let filters = [];
                    let aux = resp.data.message;
                    let ids_existentes = [];
                    for (var el in self.aux.dualist.derecha) {
                        let element = self.aux.dualist.derecha[el];
                        ids_existentes.push(element._id);
                    }

                    for (var el in aux) {
                        let elemento = aux[el];
                        if (ids_existentes.indexOf(elemento._id) < 0) {
                            filters.push(elemento);
                        }
                    }
                    self.aux.dualist.izquierda = filters;

                    let filter_estado = {
                        index: 2,
                        grupo: 'ott'
                    };

                    estadosService.getAll(filter_estado)
                        .then((resp) => {
                            self.ott.estado = resp.data.message[0];
                            EquiposTecnicos.getAll({ proyecto: self.ott.proyecto._id }).then((resp) => {
                                self.teams = resp.data;
                            })
                        });
                });

        }).catch((er) => {
            console.log(er);
        });

        vehiculoService.getAll()
            .then((resp) => {
                this.scope.aux.vehiculos = resp.data.message;
            });

        self.agregarObservacion = () => {
            let observacion = {
                text: this.scope.aux.nueva_observacion,
                // usuario: localStorage.getItem('usuario'),
                usuario: self.info.get('nombre') + ' ' + self.info.get('apellido'),
                fecha: new Date(),
                "ott": {
                    "_id": self.ott._id
                }
            };
        };

        self.guardar = () => {

            let data = this.scope.ott;
            if (this.scope.ott.protocolo == undefined) {
                if (this.scope.aux.flag_incidencia) {
                    data.protocolo = [{
                        nombre: 'default',
                        listado_tareas: this.scope.aux.dualist.derecha,
                        tipo_equipo: {
                            _id: this.scope.ott.equipo.tipo_equipo._id,
                            nombre: this.scope.ott.equipo.tipo_equipo.nombre,
                        }
                    }]
                } else {
                    this.scope.ott.protocolo = this.scope.aux.protocolos;
                }
            }

            if (!this.scope.aux.flag_incidencia) {
                let ub = this.scope.aux.ubicacion;
                this.scope.ott.ubicacion = ub;
                data.preventiva = true;
            } else {
                data.preventiva = false;
            }


            ottService.update(data)
                .then((resp) => {
                    let data_tecnicos = [];

                    for (var el in self.aux.team_final.integrantes) {
                        let tecnico = self.aux.team_final.integrantes[el];
                        data_tecnicos.push(tecnico);
                    }

                    let data = {
                        ott: {
                            _id: resp.data.message._id,
                            numero: resp.data.message.numero
                        },
                        fecha: moment(this.scope.ott.fecha_inicio).format(),
                        fecha_inicio: moment(this.scope.ott.fecha_inicio).format(),
                        fecha_termino: moment(this.scope.ott.fecha_inicio).format(),
                        equipo: {
                            _id: this.scope.aux.team_final._id,
                            nombre: 'resp.data.message.equipo.nombre'
                        },
                        tecnicos: data_tecnicos
                    };


                    CalendarioService.save(data)
                        .then(function (resp) {
                            grand_self.location.path('/ott/');
                        });
                })
        };

        self.aux.agregarTarea = this.agregarTarea.bind(this, ottService, tareasService, herramientasService, riesgoService);
        self.aux.actualizarTarea = this.actualizarTarea.bind(this, ottService);

        self.aux.get_casilla = function (grilla, row, casilla, casilla_index) {

            if (!casilla.disponible) {
                return false;
            }

            let clear = function () {
                for (var el_row in grilla.columnas) {
                    let columna = grilla.columnas[el_row];

                    for (var el_casilla in columna.casillas) {
                        let casilla = columna.casillas[el_casilla];
                        casilla.pseudo_disponible = true;
                    }
                }
            };

            let show_agenda = function () {
                casilla.pseudo_disponible = false;
                let dur_aux = duracion * 2;
                for (var i = casilla_index; i < (duracion * 2); i++) {
                    if (i < 48) {
                        let aux = row.casillas[i];
                        aux.pseudo_disponible = false;
                    }
                }

            };

            let ids_disponibles = casilla.teams_disponibles;
            let obj_teams = {};

            for (var _id in ids_disponibles) {
                let team = ids_disponibles[_id];
                obj_teams[team] = 0;
            }

            let duracion = this.duracion_ott.getHours();
            if (this.duracion_ott.getMinutes() > 0 && this.duracion_ott.getMinutes() <= 30) {
                duracion += 0.5;
            } else if (this.duracion_ott.getMinutes() > 30) {
                duracion += 1;
            }
            if (duracion > 0) {
                duracion = duracion / 0.5;
                for (var i = 0; i < duracion; i++) {
                    let indice = casilla_index + i;

                    if (indice < 49) {
                        let casilla_team_disp = grilla[row].casillas[indice].teams_disponibles;

                        for (var ids_el in casilla_team_disp) {
                            let team = casilla_team_disp[ids_el];
                            obj_teams[team] += 1;
                        }
                    }
                }
            }

            let t_raw = this.teams_raw;
            let t_final = [];

            for (var el in t_raw) {
                let aux = t_raw[el];
                if (obj_teams[aux._id] == duracion) {
                    t_final.push(aux);
                }
            }

            this.teams = t_final;

            // console.log('Inicio: ' + casilla.fecha_inicio.format());
            // console.log('Fin raw: ' + casilla.fecha_termino.format());
            // console.log('Fin: ' + moment(casilla.fecha_inicio.format()).add((duracion*60), 'm').format());
            // console.log(' ');
            let duracion_calc = (duracion * 30) - 1;

            this.casilla = {
                fecha_inicio: casilla.fecha_inicio.format(),
                fecha_termino: moment(casilla.fecha_inicio.format()).add(duracion_calc, 'm').format()
                // fecha_termino: casilla.fecha_termino.add(duracion_calc, 'm').format()
            };
        };

        this.scope.$watch('aux.tarea', (nuevo) => {
            if (nuevo !== undefined) {
                let der = nuevo.herramientas;
                this.scope.aux.tecnicos = nuevo.numero_tecnicos;
                let id_der = [];

                for (var el in der) {
                    let element = der[el];
                    id_der.push(element._id);
                }
                this.scope.aux.tools.derecha = der;
                herramientasService.getAll()
                    .then((resp) => {
                        let toFilter = resp.data.message;
                        let filter = [];
                        for (var el in toFilter) {
                            let element = toFilter[el];
                            if (id_der.indexOf(element._id) < 0) {
                                filter.push(element);
                            }
                        }
                        this.scope.aux.tools.izquierda = filter;
                    });
            }
        });

        this.scope.aux.updateTarea = () => {
            let data = this.scope.aux.tarea;
            data.numero_tecnicos = this.scope.aux.tecnicos;
            data.herramientas = this.scope.aux.tools.derecha;

            let dest = this.scope.aux.dualist.derecha;
            for (var el in dest) {
                let element = dest[el];
                if (element._id == data._id) {
                    dest[el] = element;
                }
            }
        };

        self.$watch('team_final', nuevo => {
            console.log(self)
        })

        self.aux.agendar = function (reload) {
            // console.log(self.aux.index);
            if (!reload) {
                reload = false;
            }
            self.aux.index = 3;
            this.dualist.options.active = false;
            this.tab_agendamiento = true;

            this.duracion_ott = new Date(0, 0, 0, 0, 0, 0);
            if (!this.protocolos) {
                this.protocolos = [{
                    nombre: 'default',
                    listado_tareas: this.dualist.derecha
                }];
            }

            for (var el in this.dualist.derecha) {
                let element = this.dualist.derecha[el];
                let time = new Date(element.horas_estimadas);

                this.duracion_ott.setHours(this.duracion_ott.getHours() + time.getHours());
                this.duracion_ott.setMinutes(this.duracion_ott.getMinutes() + time.getMinutes());
            }

            let fp1_i = reload ? moment(this.fecha_ott_agenda.format()) : moment().format();
            let fp1_t = reload ? moment(this.fecha_ott_agenda.add(14, 'd')) : moment().add(14, 'd').format();

            let filter_p1 = {
                "fecha": {
                    "$gte": fp1_i,
                    "$lte": fp1_t
                }
            };

            // obtenemos los registros de las ott agendadas
            let p1 = CalendarioService.getList(filter_p1);


            // obtenemos los equipos de tecnicos
            let filterP2 = {
                proyecto: this.proyectos[0]._id
            }
            let p2 = EquiposTecnicos.getAll(filterP2);


            let filter_p3 = {};

            // obtenemos la disponibilidad de equipos de tec.
            let p3 = Disponibilidad.getAll(filter_p3);


            // Promise.all([px])
            // 	.then((val)=> {
            // 	});

            $q.all([p1, p2, p3])
                .then((val) => {
                    this.teams_raw = val[1].data;
                    grand_self.agendamiento(val);
                });
        };
    }

    registrarFalla(ottService, tipoUbicacionesService, ubicacionService, inventarioService, tipoFallaService, causaFallaService) {
        let templateModal = `
			<div class="modal-content">
				<div class="modal-header">
					<h4 style="text-align:center;" class="modal-title">Registrar falla</h4>
				</div>
				<form name="regFallaForm" angular-validator novalidate ng-model="ctr" angular-validator-submit="ctr.save()">
					<div class="modal-body">
						<uib-tabset active="active">
							<uib-tab heading="Equipo">
							<div ng-repeat="el in ctr.tipo_ubicaciones">
								<div class="form-group">
									<label class="control-label col-md-5 col-sm-12 col-xs-12" for="{{el.nombre}}">{{el.nombre}} <span class="required">*</span>
									</label>
									<div class="col-md-7 col-sm-12 col-xs-12">
										<select
											class="form-control"
											ng-if="$first"
											name="{{el.nombre}}"
											id="{{el.nombre}}"
											required
                                    		required-message="'* Requerido'"
											ng-model="ctr.ubicacion[el.nombre_interno]"
											ng-options="op as op.nombre for op in ctr.selects[(el.nombre_interno + 's')] | orderBy:'nombre' ">
										</select>

										<select class="form-control" ng-if="!$first"
											ng-disabled="!ctr.ubicacion[ctr.tipo_ubicaciones[$index-1].nombre_interno]"
											ng-model="ctr.ubicacion[el.nombre_interno]"
											required
                                    		required-message="'* Requerido'"
                                    		name="{{el.nombre}}"
											id="{{el.nombre}}"
											ng-options="op as op.nombre for op in ctr.selects[(el.nombre_interno + 's')] | orderBy:'nombre' ">
										</select>
									</div>
								</div>
								<br><br>
							</div>
							<br>

							<div class="form-group" ng-if="ctr.esRequerido('equipo','ott')">
								<label class="control-label col-md-5 col-sm-5 col-xs-12" for="equipo">Equipo: <span class="required">*</span>
								</label>
								<div class="col-md-7 col-sm-12 col-xs-12">
									<select class="form-control"
										ng-model="ctr.equipo"
										required
                                    	required-message="'* Requerido'"
                                    	id="equipo"
                                    	name="equipo"
										ng-options="prioridad as prioridad.numero_serie for prioridad in ctr.equipos | orderBy:'nombre' track by prioridad._id">
									</select>
								</div>
							</div>
							<br><br>
							<br>
							<div class="clearfix"></div>
							<br>
							</uib-tab>
							<uib-tab heading="Falla">
							<br>
								<div class="form-group">
									<label class="control-label col-md-5 col-sm-12 col-xs-12" for="tipoFalla">Tipo Falla: <span class="required">*</span>
									</label>
									<div class="col-md-7 col-sm-12 col-xs-12">
										<select class="form-control"
											ng-model="ctr.tipo_falla" ng-disabled="ctr.equipo == undefined && ctr.esRequerido('equipo','ott')"
											required
                                    		required-message="'* Requerido'"
                                    		id="tipoFalla"
                                    		name="tipoFalla"
											ng-options="prioridad as prioridad.nombre for prioridad in ctr.tipo_fallas | orderBy:'nombre' track by prioridad._id">
										</select>
									</div>
									<br>
								</div>
								<br>
								<div class="form-group">
									<label class="control-label col-md-5 col-sm-12 col-xs-12" for="cuasaFalla">Causa Falla: <span class="required">*</span>
									</label>
									<div class="col-md-7 col-sm-12 col-xs-12">
										<select class="form-control"
											ng-model="ctr.causa_falla" ng-disabled="ctr.equipo == undefined && ctr.esRequerido('equipo','ott')"
											required
                                    		required-message="'* Requerido'"
                                    		id="cuasaFalla"
                                    		name="cuasaFalla"
											ng-options="prioridad as prioridad.nombre for prioridad in ctr.causa_fallas | orderBy:'nombre' track by prioridad._id">
										</select>
									</div>
								</div>
								<br><br>
								<div class="clearfix"></div>
							</uib-tab>
						</uib-tabset>
					</div>
					<div class="modal-footer">
						<button type="submit"
								class="btn btn-success pull-right"
								ng-disabled="inAction">
							Crear
						</button>
					</div>
			    </form>
			</div>
		`;

        var self = this.scope;
        let modal = this.modal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            template: templateModal,
            controller: function (equipo, tipoUbicacionesService, ubicacionService, ottService, scope,
                inventarioService, tipoFallaService, causaFallaService, ott, esRequerido) {

                var self = this;
                self.ubicacion = {};
                self.esRequerido = esRequerido;
                self.selects = {};
                let elegirEquipo = function () {
                    // let filter = {};
                    let filter = {
                        "objeto_ubicacion._id": ott.objeto_ubicacion._id
                    };

                    tipoUbicacionesService.getAll(filter)
                        .then((resp) => {
                            self.tipo_ubicaciones = resp.data.message;
                            let aux = resp.data.message[0];
                            let filter = {
                                "objeto_ubicacion._id": aux.objeto_ubicacion[0]._id,
                                "tipo.flag_hijo": false
                            };

                            ubicacionService.getAll(filter)
                                .then((resp) => {
                                    self.selects[(aux.nombre_interno + 's')] = resp.data.message;
                                    rellenarUbicaciones();
                                });
                        });
                };

                var rellenarUbicaciones = function () {
                    let data = self.tipo_ubicaciones;
                    let arCollection = [];
                    for (var el in data) {
                        let aux = data[el];
                        let str = 'ctr.ubicacion.' + aux.nombre_interno;

                        if (aux.flag_equipos) {
                            arCollection.push(str);
                        }

                        let getModel = () => {
                            return self.ubicacion[aux.nombre_interno];
                        }

                        scope.$watch(getModel, (nuevo) => {
                            if (nuevo !== undefined && !nuevo.tipo.flag_equipos) {
                                var filter = {
                                    "tipo.indice": nuevo.tipo.indice - 1,
                                    "padre._id": nuevo._id
                                }

                                let param = aux.flag_penultimo ? JSON.stringify(filter) : filter;

                                ubicacionService.getAll(param)
                                    .then((resp) => {
                                        let data = resp.data.message;
                                        if (data.length == 0) {
                                            this.toastr.warning('No existen ubicaciones dentro de la seleccionada', 'Ubicaciones', {
                                                timeOut: 2000,
                                                closeButton: true
                                            });
                                        } else {

                                            if (data[0].tipo.flag_equipos) {
                                                let auxx = resp.data.message[0].tipo.nombre_interno + 's';
                                                self.selects[auxx] = resp.data.message;
                                            } else {
                                                let ind = data[0].tipo.nombre_interno + 's';
                                                self.selects[ind] = data;
                                            }
                                        }
                                    });

                            } else if (nuevo !== undefined && nuevo.tipo.flag_equipos) {

                                if (self.esRequerido('equipo', 'ott')) {
                                    let filter = {
                                        "tipo_equipo.sub_parte": false
                                    };

                                    let ubicacion = 'ubicacion.' + nuevo.tipo.nombre_interno + '._id';
                                    filter[ubicacion] = nuevo._id;

                                    inventarioService.getAll(filter)
                                        .then((resp) => {
                                            self.equipos = resp.data.message;

                                            let getEquipo = () => {
                                                return self.equipo
                                            };
                                            scope.$watch(getEquipo, (nuevo) => {
                                                if (nuevo !== undefined) {
                                                    falla();
                                                }
                                            });
                                        });
                                } else {
                                    falla();
                                }
                            }
                        });
                    }
                };

                var falla = () => {

                    tipoFallaService.getAll()
                        .then((resp) => {
                            self.tipo_fallas = resp.data.message;
                        });

                    causaFallaService.getAll()
                        .then((rep) => {
                            self.causa_fallas = rep.data.message;
                        });
                };

                elegirEquipo();

                self.save = () => {
                    let data = {
                        tipoFalla: self.tipo_falla,
                        causaFalla: self.causa_falla
                    };

                    if (self.esRequerido('equipo', 'ott')) {
                        data.equipo = self.equipo;
                    } else {
                        data.ubicacion = self.ubicacion;
                    }

                    modal.close(data);
                };

            },
            controllerAs: 'ctr',
            size: 'md',
            resolve: {
                equipo: function () {
                    return self.ott.equipo;
                },
                tipoUbicacionesService: function () {
                    return tipoUbicacionesService;
                },
                ubicacionService: function () {
                    return ubicacionService;
                },
                ottService: function () {
                    return ottService;
                },
                scope: function () {
                    return self;
                },
                inventarioService: function () {
                    return inventarioService;
                },
                tipoFallaService: function () {
                    return tipoFallaService;
                },
                causaFallaService: function () {
                    return tipoFallaService;
                },
                ott: function () {
                    return self.ott;
                },
                esRequerido: function () {
                    return self.esRequerido;
                }
            }
        });

        modal.result.then((resp_in) => {

            let contenido = {
                "tipo_falla": resp_in.tipoFalla,
                "causa_falla": resp_in.causaFalla,
                //"equipo": resp_in.equipo,
                "ott": {
                    "_id": this.scope.ott._id
                }
            };

            if (typeof resp_in.equipo !== 'undefined') {
                contenido.equipo = resp_in.equipo;
            }
            if (typeof resp_in.ubicacion !== 'undefined') {
                contenido.ubicacion = resp_in.ubicacion;
            }

            ottService.registrarFalla(contenido)
                .then((resp) => {

                    if (!resp.data.error) {

                        let text = "";
                        if (typeof resp_in.equipo !== 'undefined') {
                            text = "Falla Registrada : tipo [" + resp_in.tipoFalla.nombre +
                                "] causa [" + resp_in.causaFalla.nombre +
                                "] numero de serie [" + resp_in.equipo.numero_serie + "]";
                        } else {
                            text = "Falla Registrada : tipo [" + resp_in.tipoFalla.nombre +
                                "] causa [" + resp_in.causaFalla.nombre + "]";
                        }
                        let observacion = [{
                            text: text,
                            usuario: self.info.get('nombre') + ' ' + self.info.get('apellido'),
                            fecha: new Date(),
                            "ott": this.scope.ott
                        }];


                        ottService.agregarObservacion(observacion)
                            .then((resp) => {
                                this.toastr.success('Falla registrada correctamente!', 'Success!', {
                                    timeOut: 2000,
                                    closeButton: true
                                });
                            });

                        if (typeof resp_in.equipo !== 'undefined') {
                            let falla = {
                                usuario: self.info.get('nombre') + ' ' + self.info.get('apellido'),
                                fecha: new Date(),
                                causa_falla: resp_in.causaFalla,
                                comentario: '-',
                                tipo_falla: resp_in.tipoFalla

                            };
                            resp_in.equipo.historial_fallas.push(falla);

                            inventarioService.update(resp_in.equipo)
                                .then((resp, err) => {
                                    // console.log(resp);
                                    console.log(err);

                                });
                        } else {
                            this.route.reload();
                        }
                    }
                });

        }, (exit) => {
            console.log('modal close');
        });
    }

    agregarTarea(ottService, tareasService, herramientasService, riesgoService, toastr) {

        let templateModal = `
			<div class="modal-content">
				<div class="modal-header">
				    <h4 style="text-align:center;" class="modal-title">Agregar Tarea</h4>
				</div>
				<div class="modal-body">
					<div class="container.">
						<div ng-if="ctr.errors.existeError" class="alert alert-danger alert-dismissible fade in" role="alert">
		                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">×</span>
		                    </button>
		                    Favor validar la información.
		                </div>
						<div class="form-horizontal form-label-left">
							<div class="row">
								<br>
								<div class="col-sm-4" ng-hide="ctr.aux.isNewTarea === true">
									<div class="form-group">
										<label class="control-label col-md-3 col-sm-3 col-xs-12" for="first-name">Tarea:
										</label>
										<div class="col-md-8 col-sm-8 col-xs-8">
											<select class="form-control"
												ng-class="{'parsley-error': ctr.errors.id}"
												ng-model="ctr.aux.tarea"
												ng-options="tarea as tarea.nombre for tarea in ctr.aux.tareas | orderBy:'nombre' track by tarea._id">
											</select>
										</div>
									</div>

								</div>
								<div class="col-sm-2" ng-hide="ctr.aux.isNewTarea === true">
									<button class="btn btn-default" ng-click="ctr.newTarea()">Nueva</button>
								</div>
								<div class="col-sm-6">
									<div class="form-group">
										<label class="control-label col-md-4 col-sm-3 col-xs-3" for="first-name">Nº técnicos: <span class="required">*</span>
										</label>
										<div class="col-md-4 col-sm-6 col-xs-12">
											<input ng-class="{'parsley-error': ctr.errors.numTecnicos}" type="number" ng-model="ctr.aux.tecnicos" class="form-control">
										</div>
									</div>
								</div>
								<br>
							</div>
							<div class="row" ng-if="ctr.aux.tarea.isNew">
								<div class="col-md-6 col-sm-6 col-xs-6">
									<div class="form-group">
										<label class="control-label col-md-4 col-sm-3 col-xs-3" for="first-name">Nombre: <span class="required">*</span>
										</label>
										<div class="col-md-6 col-sm-6 col-xs-6">
											<input ng-class="{'parsley-error': ctr.errors.nombre}" type="text" ng-model="ctr.aux.nombre" class="form-control">
										</div>
									</div>
								</div>
								<div class="col-md-6 col-sm-6 col-xs-6">
									<div class="form-group">
								    	<label class="control-label col-md-3 col-sm-3 col-xs-3" for="first-name">Riesgo
								    	</label>
								    	<div class="col-md-8 col-sm-8 col-xs-12">
								      		<select class="form-control"
								      			ng-class="{'parsley-error': ctr.errors.riesgo}"
												ng-model="ctr.aux.riesgo"
												ng-options="riesgo as riesgo.nombre for riesgo in ctr.aux.riesgos | orderBy:'nombre' track by riesgo._id">
											</select>
								    	</div>
								  	</div>
								</div>
							</div>
							<div class="row" ng-if="ctr.aux.tarea.isNew">
								<div class="col-md-12 col-sm-12 col-xs-12">
									<div class="form-group">
										<label class="control-label col-md-2 col-sm-2 col-xs-2" for="first-name">Descripcion: <span class="required">*</span>
										</label>
										<div class="col-md-10 col-sm-10 col-xs-10">
											<input ng-class="{'parsley-error': ctr.errors.descripcion}" type="text" ng-model="ctr.aux.descripcion" class="form-control">
										</div>
									</div>
								</div>
							</div>
							<div class="row" style="width:95%;margin-left:auto;margin-right:auto;">
								<div class="col-sm-12">
									<ul ng-if="ctr.errors.herramientas" class="parsley-errors-list filled" id="parsley-id-22"><li class="parsley-required">Debe seleccionar al menos una herramienta.</li></ul>
									<duallist template-url="./js/lib/ng-dualist/template.html"
										duallist-option="ctr.aux.dualist.options"
										leftscope="ctr.aux.tools.izquierda"
										rightscope="ctr.aux.tools.derecha"
										addscope="ctr.aux.tools.addVal"
										removescope="ctr.aux.tools.removeVal">
									</duallist>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
				    <button type="button" class="btn btn-success pull-right" ng-click="ctr.save()" ng-disabled="ctr.inAction">Guardar</button>
				 </div>
			</div>

			<!-- <br> -->

			<!-- <div ng-if="ctr.aux.tareas.length > 1" class="btn btn-success pull-right" ng-click="ctr.save()">Guardar</div> -->

			<!-- <div class="clearfix"></div> -->
		`;

        var self = this.scope;
        var grand_self = this;
        let modal = this.modal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            template: templateModal,
            controller: function (ottService, tareasService, herramientasService, riesgoService, toastr) {
                var vm = this;
                vm.aux = {
                    tarea: {},
                    dualist: {
                        options: {
                            leftContainerLabel: 'Herramientas Disponibles',
                            rightContainerLabel: 'Herramientas Seleccionadas',
                            active: false
                        },
                        izquierda: [],
                        derecha: [],
                        removeVal: [],
                    },
                    isNewTarea: false
                };

                vm.aux.tools = {
                    izquierda: [],
                    derecha: [],
                    removeVal: []
                };

                vm.errors = {
                    existeError: false,
                    id: false,
                    numTecnicos: false,
                    nombre: false,
                    descripcion: false,
                    riesgo: false,
                    herramientas: false
                };

                vm.data = {};

                this.main = function () {
                    vm.aux.protocolo = self.ott.protocolo[0];

                    let tareasExistentes = vm.aux.protocolo.listado_tareas;
                    let idTareasExistentes = [];
                    for (var el in tareasExistentes) {
                        let element = tareasExistentes[el];
                        idTareasExistentes.push(element._id);
                    }

                    tareasService.getAll()
                        .then((resp) => {
                            let toFilter = resp.data.message;
                            let filter = [];
                            for (var el in toFilter) {
                                let element = toFilter[el];
                                if (idTareasExistentes.indexOf(element._id) < 0) {
                                    filter.push(element);
                                }
                            }
                            vm.aux.tareas = filter;
                        });

                    riesgoService.getAll()
                        .then((resp) => {
                            vm.aux.riesgos = resp.data.message;
                        });
                };

                this.main();

                let getObj = () => {
                    return vm.aux.tarea;
                };

                self.$watch(getObj, (nuevo) => {
                    if (nuevo !== undefined) {
                        vm.aux._id = nuevo._id;
                        vm.aux.nombre = nuevo.nombre;
                        vm.aux.tecnicos = nuevo.numero_tecnicos;
                        vm.aux.horas_estimadas = nuevo.horas_estimadas;
                        vm.aux.descripcion = nuevo.descripcion;
                        vm.aux.riesgo = nuevo.riesgo;
                        vm.aux.dualist.options.active = true;

                        let der = nuevo.herramientas;

                        let id_der = [];

                        for (var el in der) {
                            let element = der[el];
                            id_der.push(element._id);
                        }

                        vm.aux.tools.derecha = der;
                        herramientasService.getAll()
                            .then((resp) => {
                                let toFilter = resp.data.message;
                                let filter = [];
                                for (var el in toFilter) {
                                    let element = toFilter[el];
                                    if (id_der.indexOf(element._id) < 0) {
                                        filter.push(element);
                                    }
                                }
                                vm.aux.tools.izquierda = filter;
                            });
                    }
                });

                this.newTarea = () => {
                    vm.aux.tarea.isNew = true;
                    vm.aux.dualist.options.active = true;
                    vm.aux.tarea.nombre = '';
                    vm.aux.tarea.descripcion = '';
                    vm.aux.isNewTarea = true;
                    vm.aux.tecnicos = 1;
                    vm.aux.horas_estimadas = 2;
                    herramientasService.getAll()
                        .then((resp) => {
                            vm.aux.tools.izquierda = resp.data.message;
                            vm.aux.tools.derecha = [];
                        });
                };

                vm.inAction = false;
                this.save = () => {
                    if (!vm.inAction) {
                        vm.inAction = true;
                    } else {
                        return;
                    }

                    vm.errors.existeError = false;
                    if (!vm.aux.tecnicos || 0 === vm.aux.tecnicos.length) {
                        vm.errors.numTecnicos = true;
                        vm.errors.existeError = true;
                    } else {
                        vm.errors.numTecnicos = false;
                    }

                    if (!vm.aux.tools.derecha || 0 === vm.aux.tools.derecha.length) {
                        vm.errors.herramientas = true;
                        vm.errors.existeError = true;
                    } else {
                        vm.errors.herramientas = false;
                    }

                    if (vm.aux.tarea.isNew) {
                        if (!vm.aux.nombre || 0 === vm.aux.nombre.length) {
                            vm.errors.nombre = true;
                            vm.errors.existeError = true;
                        } else {
                            vm.errors.nombre = false;
                        }

                        if (!vm.aux.riesgo) {
                            vm.errors.riesgo = true;
                            vm.errors.existeError = true;
                        } else {
                            vm.errors.riesgo = false;
                        }

                        if (!vm.aux.descripcion || 0 === vm.aux.descripcion.length) {
                            vm.errors.descripcion = true;
                            vm.errors.existeError = true;
                        } else {
                            vm.errors.descripcion = false;
                        }
                    } else {
                        if (vm.aux._id === undefined) {
                            vm.errors.id = true;
                            vm.errors.existeError = true;
                        } else {
                            vm.errors.id = false;
                        }
                    }

                    if (vm.errors.existeError) {
                        vm.inAction = false;
                        return;
                    }
                    let data = {
                        _id: vm.aux._id,
                        numero_tecnicos: vm.aux.tecnicos,
                        horas_estimadas: vm.aux.horas_estimadas,
                        nombre: vm.aux.nombre,
                        descripcion: vm.aux.descripcion,
                        riesgo: vm.aux.riesgo,
                        herramientas: vm.aux.tools.derecha,
                        isNew: vm.aux.isNew
                    };
                    modal.close(data);
                };
            },
            controllerAs: 'ctr',
            size: 'lg',
            resolve: {
                ottService: function () {
                    return ottService;
                }
            }
        });

        modal.result.then((resp) => {
            let contenido = {
                "numero_tecnicos": resp.numero_tecnicos,
                "horas_estimadas": resp.horas_estimadas,
                "herramientas": resp.herramientas,
                "nombre": resp.nombre,
                "descripcion": resp.descripcion,
                "riesgo": resp.riesgo,
                "estado": { _id: 1, nombre: 'pendiente' },
                "ott": {
                    "_id": self.ott._id
                }
            };

            if (!resp.isNew)
                contenido._id = resp._id;

            ottService.agregarTarea(contenido)
                .then((resp) => {
                    if (!resp.data.error) {
                        toastr.success('Tarea agreda correctamente!', 'Success!', {
                            timeOut: 2000,
                            closeButton: true
                        });
                        contenido._id = resp.data._id;
                        contenido.estado = resp.data.estado;
                        self.ott.protocolo[0].listado_tareas.push(contenido);
                        //grand_self.location.path('/ott/' + self.ott._id);
                        // window.location.reload(false);
                    }
                });
        }, (exit) => {
            console.log('modal close');
        });
    }

    registrarMovimiento(tipoUbicacionesService, ubicacionService, inventarioService, objetoUbicacionService, ottService, toastr) {
        var self = this.scope;
        let templateModal = `
			<div class="modal-content">
				<div class="modal-header">
					<h4 style="text-align:center;" class="modal-title">Movimiento de equipo</h4>
				</div>
				<div class="modal-body">
					<uib-tabset active="active">
						<uib-tab heading="Origen">
							<br>
							<div>
								<div class="form-group">
									<label class="control-label col-md-5 col-sm-12 col-xs-12" for="first-name"> Objeto Ubicación <span class="required">*</span>
									</label>
									<div class="col-md-7 col-sm-12 col-xs-12">
										<select
											class="form-control""
											name="ubicacion" ng-model="ctr.aux.objeto_ubicacion"
											ng-options="op as op.nombre for op in ctr.aux.objeto_ubicaciones | orderBy:'nombre' ">
										</select>
									</div>
								</div>
							</div>
							<br><br>
							<div ng-repeat="el in ctr.origen.tipo_ubicaciones">
								<div class="form-group">
									<label class="control-label col-md-5 col-sm-12 col-xs-12" for="first-name">{{el.nombre}} <span class="required">*</span>
									</label>
									<div class="col-md-7 col-sm-12 col-xs-12">
										<select
											class="form-control" ng-if="$first" ng-disabled="ctr.aux.objeto_ubicacion == undefined"
											name="ubicacion" ng-model="ctr.origen.ubicacion[el.nombre_interno]"
											ng-options="op as op.nombre for op in ctr.origen.selects[(el.nombre_interno + 's')] | orderBy:'nombre' ">
										</select>

										<select class="form-control" ng-if="!$first"
											ng-disabled="!ctr.origen.ubicacion[ctr.origen.tipo_ubicaciones[$index-1].nombre_interno]"
											ng-model="ctr.origen.ubicacion[el.nombre_interno]"
											ng-options="op as op.nombre for op in ctr.origen.selects[(el.nombre_interno + 's')] | orderBy:'nombre' ">
										</select>
									</div>
								</div>
								<br><br>
							</div>
							<br>

                            <div class="form-group" ng-if="ctr.esRequerido('equipo','ott')">
								<label class="control-label col-md-5 col-sm-5 col-xs-12" for="first-name">Equipo: <span class="required">*</span>
								</label>
								<div class="col-md-7 col-sm-12 col-xs-12">
									<select class="form-control"
										ng-model="ctr.equipo"
										ng-options="prioridad as prioridad.nombre + ' ' + prioridad.numero_serie for prioridad in ctr.equipos | orderBy:'nombre' track by prioridad._id">
									</select>
								</div>
							</div>
							<div class="clearfix"></div>
							<br>
						</uib-tab>
						<uib-tab heading="Destino">
						<br>
						<div class="form-group">
							<label class="control-label col-md-5 col-sm-12 col-xs-12" for="first-name">Objeto ubicación: <span class="required">*</span>
							</label>
							<div class="col-md-7 col-sm-12 col-xs-12">
								<select class="form-control"
									ng-model="ctr.objeto_ubicacion"
									ng-options="prioridad as prioridad.nombre for prioridad in ctr.objeto_ubicaciones | orderBy:'nombre' track by prioridad._id">
								</select>
							</div>
						</div>
						<br><br>
						<div ng-repeat="el in ctr.destino.tipo_ubicaciones">
							<div class="form-group">
								<label class="control-label col-md-5 col-sm-12 col-xs-12" for="first-name">{{el.nombre}} <span class="required">*</span>
								</label>
								<div class="col-md-7 col-sm-12 col-xs-12">
									<select
										class="form-control" ng-if="$first"
										name="ubicacion" ng-model="ctr.destino.ubicacion[el.nombre_interno]"
										ng-options="op as op.nombre for op in ctr.destino.selects[(el.nombre_interno + 's')] | orderBy:'nombre' ">
									</select>

									<select class="form-control" ng-if="!$first"
										ng-disabled="!ctr.destino.ubicacion[ctr.destino.tipo_ubicaciones[$index-1].nombre_interno]"
										ng-model="ctr.destino.ubicacion[el.nombre_interno]"
										ng-options="op as op.nombre for op in ctr.destino.selects[(el.nombre_interno + 's')] | orderBy:'nombre' ">
									</select>
								</div>
							</div>
							<br><br>
						</div>
							<div class="clearfix"></div>
						</uib-tab>
					</uib-tabset>
				</div>
				<div class="modal-footer">
					<div class="btn btn-success pull-right" ng-click="ctr.save()">Guardar</div>
			    </div>
			</div>
		`;

        let modal = this.modal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            template: templateModal,
            controller: function (tipoUbicacionesService, ubicacionService, inventarioService, ott, scope, objetoUbicacionService, toastr) {
                var self = this;
                self.aux = {
                    equipo: false
                };
                self.origen = {};
                self.destino = {};
                self.origen.ubicacion = {};
                self.origen.selects = {};
                self.destino.ubicacion = {};
                self.destino.selects = {};


                let elegirEquipoOrigen = function () {
                    let filtro = {
                        "proyecto": ott.proyecto._id
                    }
                    objetoUbicacionService.getAll(filtro)
                        .then((resp) => {
                            self.aux.objeto_ubicaciones = resp.data.message;

                            let getModel = () => {
                                return self.aux.objeto_ubicacion;
                            }

                            scope.$watch(getModel, (nuevo) => {
                                if (nuevo !== undefined) {
                                    let filter = {
                                        "objeto_ubicacion._id": self.aux.objeto_ubicacion._id
                                    };

                                    tipoUbicacionesService.getAll(filter)
                                        .then((resp) => {
                                            self.origen.tipo_ubicaciones = resp.data.message;
                                            let aux = resp.data.message[0];

                                            let filter = {
                                                "objeto_ubicacion._id": aux.objeto_ubicacion[0]._id,
                                                "tipo.flag_hijo": false
                                            };

                                            ubicacionService.getAll(filter)
                                                .then((resp) => {
                                                    self.origen.selects[(aux.nombre_interno + 's')] = resp.data.message;
                                                    rellenarUbicacionesOrigen();
                                                });
                                        });
                                }
                            });

                        });
                };

                var rellenarUbicacionesOrigen = function () {
                    let data = self.origen.tipo_ubicaciones;
                    let arCollection = [];
                    for (var el in data) {
                        let aux = data[el];

                        let str = 'ctr.ubicacion.' + aux.nombre_interno;

                        if (aux.flag_equipos) {
                            arCollection.push(str);
                        }

                        let getModel = () => {
                            return self.origen.ubicacion[aux.nombre_interno];
                        };

                        scope.$watch(getModel, (nuevo) => {
                            if (nuevo != null && angular.isDefined(nuevo) && angular.isDefined(nuevo.tipo) && !nuevo.tipo.flag_equipos) {
                                var filter = {
                                    "tipo.indice": nuevo.tipo.indice - 1,
                                    "padre._id": nuevo._id
                                };

                                let param = aux.flag_penultimo ? JSON.stringify(filter) : filter;

                                ubicacionService.getAll(param)
                                    .then((resp) => {
                                        let data = resp.data.message;
                                        if (data.length == 0) {
                                            //alert("No existen ubicaciones dentro de la seleccionada");
                                            toastr.warning('No existen ubicaciones dentro de la seleccionada', 'Ubicaciones', {
                                                timeOut: 2000,
                                                closeButton: true
                                            });
                                        } else {

                                            if (data[0].tipo.flag_equipos) {
                                                let auxx = resp.data.message[0].tipo.nombre_interno + 's';
                                                self.origen.selects[auxx] = resp.data.message;
                                            } else {
                                                let ind = data[0].tipo.nombre_interno + 's';
                                                self.origen.selects[ind] = data;
                                            }
                                        }
                                    });

                            } else if (nuevo != null && nuevo !== undefined && nuevo.tipo.flag_equipos) {

                                if (!self.esRequerido('equipo', 'ott')) {
                                    return;
                                }
                                let filter = {
                                    // "tipo_equipo.sub_parte" : false
                                }

                                let ubicacion = 'ubicacion.' + nuevo.tipo.nombre_interno + '._id';
                                filter[ubicacion] = nuevo._id;

                                inventarioService.getAll(filter)
                                    .then((resp) => {
                                        self.equipos = resp.data.message;

                                        let getEquipo = () => {
                                            return self.equipo
                                        };

                                        scope.$watch(getEquipo, (nuevo) => {
                                            if (nuevo !== undefined) {
                                                self.aux.equipo = true;
                                            }
                                        });
                                    });
                            }
                        });
                    }
                };

                let elegirEquipoDestino = function () {

                    let getInicial = () => {
                        return self.aux.objeto_ubicacion;
                    };
                    scope.$watch(getInicial, (nuevo) => {
                        if (nuevo !== undefined) {
                            let filter = {
                                proyecto: ott.proyecto._id
                            };

                            if (self.aux.objeto_ubicacion.flag_receptor) {
                                filter.flag_destino = true;
                            } else {
                                filter.flag_receptor = true;
                            }
                            // let filter = {
                            // 	"objeto_ubicacion._id": equipo.ubicacion[Object.keys(equipo.ubicacion)[0]].objeto_ubicacion._id
                            // };
                            objetoUbicacionService.getAll(filter)
                                .then((resp) => {
                                    self.objeto_ubicaciones = resp.data.message;
                                });
                        }
                    });


                    let getObj = () => {
                        return self.objeto_ubicacion;
                    };

                    scope.$watch(getObj, (nuevo) => {
                        if (nuevo !== undefined) {
                            let filter = {
                                "objeto_ubicacion._id": nuevo._id
                            };

                            tipoUbicacionesService.getAll(filter)
                                .then((resp) => {
                                    self.destino.tipo_ubicaciones = resp.data.message;
                                    let aux = resp.data.message[0];

                                    let filter = {
                                        "objeto_ubicacion._id": aux.objeto_ubicacion[0]._id,
                                        "tipo.flag_hijo": false
                                    };

                                    ubicacionService.getAll(filter)
                                        .then((resp) => {
                                            self.destino.selects[(aux.nombre_interno + 's')] = resp.data.message;
                                            rellenarUbicacionesDestino();
                                        });
                                });
                        }
                    });
                };

                var rellenarUbicacionesDestino = function () {
                    let data = self.destino.tipo_ubicaciones;
                    let arCollection = [];
                    for (var el in data) {
                        let aux = data[el];
                        let str = 'ctr.ubicacion.' + aux.nombre_interno;

                        if (aux.flag_equipos) {
                            arCollection.push(str);
                        }

                        let getModel = () => {
                            return self.destino.ubicacion[aux.nombre_interno];
                        };

                        scope.$watch(getModel, (nuevo) => {
                            if (nuevo !== undefined && !nuevo.tipo.flag_equipos) {

                                var filter = {
                                    "tipo.indice": nuevo.tipo.indice - 1,
                                    "padre._id": nuevo._id
                                };

                                if (aux.flag_penultimo && typeof self.equipo !== 'undefined' && !self.equipo.tipo_equipo.sub_parte) {
                                    filter.$or = [
                                        {
                                            "tipo_equipo._id": self.equipo.tipo_equipo._id,
                                            "tipo_equipo.flag_disponible": true
                                        },
                                        {
                                            "objeto_ubicacion.flag_receptor": true
                                        }
                                    ]
                                }

                                // if (aux.flag_penultimo && self.equipo.tipo_equipo.sub_parte) {
                                // 	filter.$or = [
                                // 		{
                                // 			"objeto_ubicacion.flag_receptor": this.scope.aux.flag_receptor
                                // 		}
                                // 	];
                                // }

                                let param = aux.flag_penultimo ? JSON.stringify(filter) : filter;

                                ubicacionService.getAll(param)
                                    .then((resp) => {
                                        let data = resp.data.message;
                                        if (data.length == 0) {
                                            //alert("No existen ubicaciones dentro de la seleccionada");
                                            toastr.warning('No existen ubicaciones dentro de la seleccionada', 'Ubicaciones', {
                                                timeOut: 2000,
                                                closeButton: true
                                            });
                                        } else {

                                            if (data[0].tipo.flag_equipos) {
                                                let auxx = resp.data.message[0].tipo.nombre_interno + 's';
                                                self.destino.selects[auxx] = resp.data.message;
                                            } else {
                                                let ind = data[0].tipo.nombre_interno + 's';
                                                self.destino.selects[ind] = data;
                                            }
                                        }
                                    });

                            } else if (nuevo !== undefined && nuevo.tipo.flag_equipos) {
                                // let filter = {
                                // 	"tipo_equipo.sub_parte" : false
                                // }
                                //
                                // let ubicacion = 'ubicacion.' + nuevo.tipo.nombre_interno + '._id';
                                // filter[ubicacion] = nuevo._id;
                                //
                                // inventarioService.getAll(filter)
                                // 	.then((resp) => {
                                // 		self.equipos = resp.data.message;
                                //
                                // 		let getEquipo = () => {
                                // 			return self.equipo
                                // 		};
                                //
                                // 		scope.$watch(getEquipo, (nuevo) => {
                                // 			if (nuevo !== undefined) {
                                // 				console.log(nuevo);
                                // 			}
                                // 		});
                                // 	});
                            }
                        });
                    }
                };

                elegirEquipoOrigen();
                elegirEquipoDestino();

                self.save = () => {
                    let ubNew;
                    let elAux = '';
                    let indexAux = 51;

                    let aux = self.destino.ubicacion;
                    for (var el in aux) {
                        let element = aux[el];
                        if (element.tipo.indice < indexAux) {
                            indexAux = element.tipo.indice;
                            elAux = el;
                        }
                    }
                    if (angular.isUndefined(aux[elAux])) {
                        toastr.error('Debe seleccionar una ubicación de destino', 'Ubicaciones', {
                            timeOut: 2000,
                            closeButton: true
                        });
                        return;
                    }
                    ubNew = aux[elAux];

                    let ubOld;
                    let elAuxOld = '';
                    let indexAuxOld = 50;
                    let auxOld = self.origen.ubicacion;
                    for (var el in auxOld) {
                        let element = auxOld[el];
                        if (element.tipo.indice < indexAuxOld) {
                            indexAuxOld = element.tipo.indice;
                            elAuxOld = el;
                        }
                    }
                    ubOld = auxOld[elAuxOld];

                    let data = {
                        ubicacion_nueva: self.destino.ubicacion,
                        ubicacion_anterior: self.origen.ubicacion,
                        ubicacion_new: {
                            "_id": ubNew._id,
                            "bodega": ubNew.tipo.flag_bodega
                        },
                        ubicacion_old: ubOld._id
                    };

                    if (typeof ott.equipo !== 'undefined') {
                        data.equipo = {
                            "_id": ott.equipo._id,
                            "tipo_equipo": ott.equipo.tipo_equipo_id
                        }
                    }

                    modal.close(data);
                }

                self.esRequerido = (element, tab) => {
                    let result = true;
                    if (ott !== 'undefined' && ott != null) {
                        let proyecto = ott.proyecto;
                        if (typeof proyecto !== "undefined" && proyecto != null) {
                            if (typeof proyecto.no_requeridos !== "undefined" && proyecto.no_requeridos != null) {
                                if (typeof proyecto.no_requeridos[tab] !== "undefined" && proyecto.no_requeridos[tab] != null) {
                                    result = proyecto.no_requeridos[tab].indexOf(element) == -1;
                                }
                            }
                        }
                    }
                    return result;
                }

            },
            controllerAs: 'ctr',
            size: 'md',
            resolve: {
                tipoUbicacionesService: function () {
                    return tipoUbicacionesService;
                },
                ubicacionService: function () {
                    return ubicacionService;
                },
                inventarioService: function () {
                    return inventarioService;
                },
                ott: function () {
                    return self.ott;
                },
                scope: function () {
                    return self;
                },
                objetoUbicacionService: function () {
                    return objetoUbicacionService;
                }
            }
        });

        modal.result.then((resp) => {
            resp.ott = {
                _id: this.scope.ott._id
            }
            ottService.moverEquipo(resp)
                .then((resp) => {
                    this.toastr.success('Equipo reposicionado correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                }).catch((er) => {
                    console.log(er);
                });

        }, (er) => {
            console.log('modal cerrado');
        });
    }

    create(ottService,
        $routeParams,
        incidenciaService,
        inventarioService,
        protocolosService,
        tareasService,
        herramientasService,
        prioridadesService,
        proyectosService,
        objetoUbicacionService,
        ubicacionService,
        tipoUbicacionesService,
        CalendarioService,
        EquiposTecnicos,
        Disponibilidad,
        $q,
        periodosService,
        vehiculoService,
        tipoEquipoService,
        info,
        problemaCorrectivoService,
        nivelIncidenciaService) {

        let self = this;
        this.scope.$watch("readOnly", function (newVal) {
            if (newVal) {
                self.location.path('/ott/');
            }
        });

        this.scope.aux = {
            ubicacion: {},
            selects: {},
            teams_raw: {},
            teams: {},
            tipo_ott: 'normal',
            fecha_ott_model: null,
            fecha_ott_agenda: null,
            lock_ubicacion: true,
            index: 0
        };

        this.scope.aux.periodos = [];

        this.scope.ott = {};
        this.scope.aux.dualist = {
            options: {
                leftContainerLabel: 'Listado Tareas',
                rightContainerLabel: 'Tareas Seleccionadas',
                active: true
            },
            izquierda: [],
            derecha: [],
            removeVal: [],
        };

        this.scope.flag_new_protocolo = false;


        this.scope.aux.tools = {
            options: {
                leftContainerLabel: 'Listado Herramientas',
                rightContainerLabel: 'Herramientas Seleccionadas',
                active: false
            },
            izquierda: [],
            derecha: [],
            removeVal: []
        };

        this.scope.aux.selects = {};

        let incidenciaId = $routeParams.id;
        var flag_incidencia = incidenciaId !== undefined ? true : false;
        this.scope.aux.flag_incidencia = flag_incidencia;
        this.scope.aux.disableEquipos = !flag_incidencia ? 1 : 0;
        this.scope.aux.flag_incidencia = flag_incidencia;

        if (flag_incidencia) {
            let filter = {
                _id: incidenciaId
            };

            incidenciaService.getById(filter)
                .then((resp) => {

                    this.scope.incidencia = resp.data.message;
                    let incidencia = resp.data.message;
                    let prioridad = incidencia.prioridad;
                    let proyecto = incidencia.proyecto;
                    let equipo = incidencia.equipo;
                    let ubAux = Object.keys(incidencia.ubicacion);

                    this.scope.ott.prioridad = prioridad;
                    this.scope.ott.incidencia = incidencia;
                    this.scope.aux.prioridades = [prioridad];
                    this.scope.ott.proyecto = proyecto;
                    this.scope.aux.proyectos = [proyecto];
                    this.scope.aux.obj_ubicacion = incidencia.ubicacion[ubAux[0]].objeto_ubicacion;

                    this.scope.aux.obj_ubicaciones = [incidencia.ubicacion[ubAux[0]].objeto_ubicacion];
                    this.scope.aux.tipo_ubicaciones = incidencia.ubicacion;

                    for (var el in incidencia.ubicacion) {
                        let element = incidencia.ubicacion[el];
                        this.scope.aux.ubicacion[element.tipo.nombre_interno] = element;
                        this.scope.aux.selects[(element.tipo.nombre_interno + 's')] = [element];
                        if (element.tipo.flag_equipos === true && !this.scope.esRequerido('equipo')) {
                            let filterProtocolo = {
                                "proyecto": proyecto._id,
                                "tipo_equipo._id": element.tipo_equipo._id
                            };
                            protocolosService.getAll(filterProtocolo)
                                .then((resp) => {
                                    this.scope.aux.protocolos = resp.data.message;
                                });
                        }
                    }

                    //llamar equipos sin agenda
                    if (!this.scope.esRequerido("agenda")) {
                        // obtenemos los equipos de tecnicos
                        let filterP2 = {
                            proyecto: proyecto._id
                        }
                        EquiposTecnicos.getAll(filterP2).then((val) => {
                            this.scope.aux.teams = val.data;
                        });
                    }

                    this.scope.ott.observaciones = [];
                    for (var el in incidencia.historial) {
                        var observacion = {};

                        let element = incidencia.historial[el];

                        observacion.fecha = element.fecha_cambio;
                        observacion.usuario = element.usuario;
                        if (element.campo === 'Observaciones')
                            observacion.text = element.campo + ": " + element.valor_campo;
                        else
                            observacion.text = element.campo + ": " + element.comentario;
                        this.scope.ott.observaciones.push(observacion);
                    }
                    this.scope.aux.equipos = [equipo];
                    this.scope.ott.equipo = equipo;
                });
        } else {
            this.scope.ott.tipo_ott = 'preventiva';
        }

        // llamadas cuando son ott programadas
        if (!flag_incidencia) {
            prioridadesService.getAll()
                .then((resp) => {
                    this.scope.aux.prioridades = resp.data.message;
                });

            tareasService.getAll()
                .then((resp) => {
                    this.scope.aux.dualist.izquierda = resp.data.message;
                    this.scope.aux.dualist.derecha = [];
                });

            proyectosService.getAll()
                .then((resp) => {
                    this.scope.aux.proyectos = resp.data.message;
                    console.log(this.scope.aux.proyectos)
                });



            self.scope.$watch('ott.proyecto', (nuevo) => {
                if (nuevo !== undefined) {
                    let filter = {
                        "proyecto": nuevo._id
                    };

                    objetoUbicacionService.getAll(filter)
                        .then((resp) => {
                            this.scope.aux.obj_ubicaciones = resp.data.message;
                            console.log(this.scope.aux.obj_ubicaciones)
                        });

                    let filterProtocolo = {
                        "flag_preventivo": true,
                        "proyecto": nuevo._id,
                    };
                    protocolosService.getAll(filterProtocolo)
                        .then((resp) => {
                            this.scope.aux.protocolos = resp.data.message;
                        });

                    if (!this.scope.esRequerido("agenda")) {
                        // obtenemos los equipos de tecnicos
                        let filterP2 = {
                            proyecto: nuevo._id
                        }
                        EquiposTecnicos.getAll(filterP2).then((val) => {
                            this.scope.aux.teams = val.data;
                        });
                    }

                    if (!this.scope.esRequerido("tipo_ott")) {
                        this.scope.ott.preventiva = false;
                    }

                    this.scope.aux.tipo_equipos = nuevo.listado_tipo_equipo;
                }
            });

            this.scope.$watch('aux.obj_ubicacion', (nuevo) => {
                if (nuevo !== undefined) {
                    let filter = {
                        "objeto_ubicacion._id": nuevo._id
                    }
                    tipoUbicacionesService.getAll(filter)
                        .then((resp) => {
                            let sirven = [];
                            for (var el in resp.data.message) {
                                let aux = resp.data.message[el];
                                if (!aux.flag_preventivo) {
                                    sirven.push(aux);
                                } else {
                                    sirven.push(aux);
                                    break;
                                }
                            }
                            this.scope.aux.tipo_ubicaciones = sirven;
                            console.log(this.scope.aux.tipo_ubicaciones)
                            rellenarUbicaciones(nuevo);
                        });
                }
            });
            this.scope.$watch('aux.tipo_equipos', (nuevo) => {
                if (typeof nuevo !== 'undefined') {

                    for (var property in this.scope.aux.ubicacion) {
                        if (this.scope.aux.ubicacion.hasOwnProperty(property)) {
                            this.scope.aux.ubicacion[property] = null;
                        }
                    }

                    for (var property in this.scope.aux.tipo_ubicaciones) {
                        if (this.scope.aux.tipo_ubicaciones.hasOwnProperty(property)) {
                            if (this.scope.aux.tipo_ubicaciones[property].flag_hijo === true) {
                                this.scope.aux.selects[this.scope.aux.tipo_ubicaciones[property].nombre_interno + 's'] = [];
                            }
                        }
                    }

                    if (typeof nuevo.jornada !== 'undefined') {
                        this.scope.ott.jornada = nuevo.jornada;
                    } else {
                        this.scope.ott.jornada = null;
                    }

                    let filterProtocolo = {
                        "flag_preventivo": true,
                        "proyecto": this.scope.ott.proyecto._id,
                        "tipo_equipo._id": nuevo._id
                    };
                    protocolosService.getAll(filterProtocolo)
                        .then((resp) => {
                            this.scope.aux.protocolos = resp.data.message;
                        });
                }
            });

            this.scope.$watch('aux.tipo_equipo', (nuevo) => {
                if (typeof nuevo !== 'undefined') {

                    for (var property in this.scope.aux.ubicacion) {
                        if (this.scope.aux.ubicacion.hasOwnProperty(property)) {
                            this.scope.aux.ubicacion[property] = null;
                        }
                    }

                    for (var property in this.scope.aux.tipo_ubicaciones) {
                        if (this.scope.aux.tipo_ubicaciones.hasOwnProperty(property)) {
                            if (this.scope.aux.tipo_ubicaciones[property].flag_hijo === true) {
                                this.scope.aux.selects[this.scope.aux.tipo_ubicaciones[property].nombre_interno + 's'] = [];
                            }
                        }
                    }

                    if (typeof nuevo.jornada !== 'undefined') {
                        this.scope.ott.jornada = nuevo.jornada;
                    } else {
                        this.scope.ott.jornada = null;
                    }

                    let filterProtocolo = {
                        "flag_preventivo": this.scope.ott.tipo_ott == 'preventiva' ? true : false,
                        "proyecto": this.scope.ott.proyecto._id,
                        "tipo_equipo._id": nuevo._id
                    };
                    protocolosService.getAll(filterProtocolo)
                        .then((resp) => {
                            this.scope.aux.protocolos = resp.data.message;
                        });
                }
            });

            /*tipoEquipoService.getAll()
            .then((resp) => {
                this.scope.aux.tipo_equipos = resp.data.message;
            });*/

            var rellenarUbicaciones = (nuevo) => {

                let filter = {
                    'tipo.indice': 50,
                    'objeto_ubicacion._id': nuevo._id
                };
                ubicacionService.getAll(filter).then((resp, err) => {
                    if (!err) {
                        if (resp.data.message.length == 0) {
                            this.toastr.warning('No existen sectores disponibles para el area seleccionada', 'Ubicaciones', {
                                timeOut: 2000,
                                closeButton: true
                            });
                        }
                        let index = this.scope.aux.tipo_ubicaciones[0].nombre_interno + 's';
                        this.scope.aux.selects[index] = resp.data.message;
                    }
                });

                let data = this.scope.aux.tipo_ubicaciones;
                let arCollection = [];
                for (var el in data) {
                    let aux = data[el];
                    let str = 'aux.ubicacion.' + aux.nombre_interno;
                    if (aux.flag_equipos) {
                        arCollection.push(str);
                    }
                    this.scope.aux.ubicacion[aux.nombre_interno] = null;
                    this.scope.$watch('aux.ubicacion.equipo.tipo_equipo', nuevo => {
                        if (typeof nuevo !== 'undefined') {
                            let filterProtocolo = {
                                "flag_preventivo": true,
                                "proyecto": this.scope.ott.proyecto._id,
                                "tipo_equipo._id": nuevo._id
                            };
                            protocolosService.getAll(filterProtocolo)
                                .then((resp) => {
                                    this.scope.aux.protocolos = resp.data.message;
                                });
                        }
                    });

                    this.scope.$watch('aux.ubicacion.tipo_dispositivo', nuevo => {
                        if (typeof nuevo !== 'undefined' && nuevo !== null) {
                            let filterProtocolo = {
                                "proyecto": this.scope.ott.proyecto._id,
                                "tipo_equipo._id": nuevo.tipo_equipo._id
                            };
                            protocolosService.getAll(filterProtocolo)
                                .then((resp) => {
                                    this.scope.aux.protocolos = resp.data.message;
                                });
                        }
                    })
                    
                    this.scope.$watch(str, (nuevo) => {
                        if (typeof nuevo !== 'undefined' && nuevo !== null && !nuevo.tipo.flag_equipos) {

                            var filter = {
                                "tipo.indice": nuevo.tipo.indice - 1,
                                "padre._id": nuevo._id
                            }

                            if (typeof this.scope.aux.tipo_equipo != 'undefined') {
                                filter['tipo_equipo._id'] = this.scope.aux.tipo_equipo._id
                            }

                            let param = aux.flag_penultimo ? JSON.stringify(filter) : filter;

                            ubicacionService.getAll(param)
                                .then((resp) => {
                                    let data = resp.data.message;
                                    if (data.length == 0) {

                                        this.toastr.warning('No existen ubicaciones dentro de la seleccionada', 'Ubicaciones', {
                                            timeOut: 2000,
                                            closeButton: true
                                        });
                                    } else {
                                        let ind = data[0].tipo.nombre_interno + 's';
                                        let stru = "aux.ubicacion." + data[0].tipo.nombre_interno;
                                        this.scope.aux.selects[ind] = data;
                                        if (this.scope.ott.proyecto.nombre == 'AVO 1' || this.scope.ott.proyecto.nombre == 'CANOPSA') {
                                            this.scope.$watch(stru, (nuevou) => {
                                                //get serial number
                                                if (this.scope.aux.ubicacion.tramo && this.scope.aux.ubicacion.posicion) {
                                                    let posname = this.scope.aux.ubicacion.posicion.nombre == 'Gabinete de Interfaz 1' ? 'Gabinete 1' : this.scope.aux.ubicacion.posicion.nombre;
                                                    inventarioService.getSerialNumber({ location: this.scope.aux.ubicacion.tramo.nombre, position: posname, project: this.scope.ott.proyecto.nombre }).then((resp) => {
                                                        this.scope.ott.serial_number = resp.data.message.message;
                                                    });
                                                } else {

                                                }
                                            })
                                        }
                                    }
                                });
                        } else if (typeof nuevo !== 'undefined' && nuevo !== null && nuevo.tipo.flag_equipos) {
                            if (str == "aux.ubicacion.equipo" && this.scope.ott.tipo_ott == 'correctiva' && !this.scope.esRequerido('tipo_equipo')) {
                                problemaCorrectivoService.getAll({ tipoequipo: nuevo.tipo_equipo._id }).then((resp) => {
                                    this.scope.aux.problemascorrectivos = resp.data.message;
                                })
                            }
                        }
                    });
                }
            }
        }

        vehiculoService.getAll()
            .then((resp) => {
                this.scope.aux.vehiculos = resp.data.message;
            });

        nivelIncidenciaService.getAll().then((resp) => {
            this.scope.nivelincidencias = resp.data.message;
        })

        this.scope.$watch('ott.equipo', (nuevo) => {
            if (nuevo) {
                let filter = {
                    "tipo_equipo._id": nuevo.tipo_equipo._id,
                    "proyecto": this.scope.ott.proyecto._id,
                };

                protocolosService.getAll(filter)
                    .then((resp) => {
                        this.scope.aux.protocolos = resp.data.message;
                    });
            }
        });

        this.scope.$watch('ott.protocolo', (nuevo) => {
            if (nuevo !== undefined) {
                this.scope.flag_new_protocolo = false;
                this.scope.aux.dualist.derecha = nuevo.listado_tareas;
                tareasService.getAll()
                    .then((resp) => {
                        let derecha = [];
                        let der = this.scope.aux.dualist.derecha;
                        for (var el in der) {
                            let elemento = der[el];
                            derecha.push(elemento._id);
                        }

                        let izFiltrada = [];
                        let aux2 = resp.data.message;
                        for (var el in aux2) {
                            let elemento = aux2[el];
                            if (derecha.indexOf(elemento._id) < 0) {
                                izFiltrada.push(elemento);
                            }
                        }
                        this.scope.aux.dualist.izquierda = izFiltrada;
                    });
            }
        });

        this.scope.$watch('aux.tarea', (nuevo) => {
            if (nuevo !== undefined) {
                this.scope.aux.tools.options.active = true;

                let der = nuevo.herramientas;
                this.scope.aux.tecnicos = nuevo.numero_tecnicos;
                let id_der = [];

                for (var el in der) {
                    let element = der[el];
                    id_der.push(element._id);
                }
                this.scope.aux.tools.derecha = der;
                herramientasService.getAll()
                    .then((resp) => {
                        let toFilter = resp.data.message;
                        let filter = [];
                        for (var el in toFilter) {
                            let element = toFilter[el];
                            if (id_der.indexOf(element._id) < 0) {
                                filter.push(element);
                            }
                        }
                        this.scope.aux.tools.izquierda = filter;
                    });
            }
        });

        this.scope.getTareas = () => {

            this.scope.flag_new_protocolo = true;

            tareasService.getAll()
                .then((resp) => {
                    this.scope.aux.dualist.izquierda = resp.data.message;
                    this.scope.aux.dualist.derecha = [];
                });
        };

        this.scope.updateTarea = () => {
            let data = this.scope.aux.tarea;
            data.numero_tecnicos = this.scope.aux.tecnicos;
            data.herramientas = this.scope.aux.tools.derecha;

            let dest = this.scope.aux.dualist.derecha;
            for (var el in dest) {
                let element = dest[el];
                if (element._id == data._id) {
                    dest[el] = element;
                }
            }
        };

        this.scope.guardar = () => {
            let data = this.scope.ott;

            if (typeof this.scope.aux.team_final === 'undefined') {
                self.toastr.error('Debe seleccionar un team', 'Failed!', {
                    timeOut: 3000,
                    closeButton: true
                });
                return;
            }

            if (this.scope.ott.tipo_ott == 'correctiva' && this.scope.esRequerido('glpi', 'ott') && (typeof this.scope.ott.glpi === 'undefined' || this.scope.ott.glpi == '')) {
                self.toastr.error('Debe ingresar el GLPI', 'Failed!', {
                    timeOut: 3000,
                    closeButton: true
                });
                return;
            }

            if (this.scope.ott.tipo_ott == 'preventiva' && this.scope.esRequerido('tipo_obra') && (typeof this.scope.ott.tipo_obra === 'undefined' || this.scope.ott.tipo_obra == '')) {
                self.toastr.error('Debe seleccionar el tipo de obra', 'Failed!', {
                    timeOut: 3000,
                    closeButton: true
                });
                return;
            }

            if (this.scope.esRequerido('tipo_equipo') && (typeof this.scope.aux.tipo_equipo === 'undefined' || typeof this.scope.aux.tipo_equipo._id === 'undefined')) {
                self.toastr.error('Debe seleccionar el tipo de equipo', 'Failed!', {
                    timeOut: 3000,
                    closeButton: true
                });
                return;
            }

            if (this.scope.ott.tipo_ott == 'correctiva' && this.scope.esRequerido('numero_ticket', 'ott') && (typeof this.scope.ott.numero_ticket === 'undefined' || this.scope.ott.numero_ticket == '')) {
                self.toastr.error('Debe ingresar el numero de ticket', 'Failed!', {
                    timeOut: 3000,
                    closeButton: true
                });
                return;
            }

            let valid = true;
            for (let tipo of this.scope.aux.tipo_ubicaciones) {
                if (this.scope.aux.ubicacion[tipo.nombre_interno] == null) {
                    valid = false
                }
            }

            if (!valid) {
                self.toastr.error('Debe seleccionar Posicion o Ubicacion', 'Failed!', {
                    timeOut: 3000,
                    closeButton: true
                });
                return;
            }

            if (!this.scope.ott.hasOwnProperty('fecha_inicio')) {
                self.toastr.error('Debe seleccionar Fecha', 'Failed!', {
                    timeOut: 3000,
                    closeButton: true
                });
                return;
            }

            if (this.scope.ott.protocolo == undefined) {
                if (typeof this.scope.ott.equipo !== 'undefined') {
                    data.protocolo = [{
                        nombre: 'default',
                        listado_tareas: this.scope.aux.dualist.derecha
                    }]

                    if (this.scope.esRequerido('tipo_equipo')) {
                        data.protocolo[0]["tipo_equipo"] = {
                            _id: this.scope.ott.equipo.tipo_equipo._id,
                            nombre: this.scope.ott.equipo.tipo_equipo.nombre,
                        }
                    }
                } else {
                    data.protocolo = [{
                        nombre: 'default',
                        listado_tareas: this.scope.aux.dualist.derecha
                    }]

                    if (this.scope.esRequerido('tipo_equipo')) {
                        data.protocolo[0]["tipo_equipo"] = {
                            _id: this.scope.aux.tipo_equipo._id,
                            nombre: this.scope.aux.tipo_equipo.nombre,
                        }
                    }
                }
            }


            if (this.scope.aux.flag_incidencia) {
                let ub = this.scope.aux.ubicacion;
                this.scope.ott.ubicacion = ub;
                data.preventiva = true;

            } else {
                let ub = this.scope.aux.ubicacion;
                this.scope.ott.ubicacion = ub;
                if (typeof this.scope.ott.tipo_ott !== 'undefined') {
                    data.preventiva = (this.scope.ott.tipo_ott == 'correctiva');
                } else {
                    data.preventiva = false;
                }

            }
            // si no esta permitido la agenda se saca de los valores de ott            
            let fi = null;
            let ft = null;
            if (this.scope.esRequerido('agenda')) {
                fi = this.scope.aux.casilla.fecha_inicio;
                ft = this.scope.aux.casilla.fecha_termino;
                data.fecha_inicio = fi;
            } else {
                fi = data.fecha_inicio;
                ft = data.fecha_inicio;
            }
            let element = {};
            for (var propt in this.scope.aux.ubicacion) {
                element[propt] = this.scope.aux.ubicacion[propt];
            }
            data.ubicacion = element;

            //guardar team dentro del objeto a enviar a servidor

            data.team = this.scope.aux.team_final;
            ottService.save(data).then((resp) => {

                let data_tecnicos = [];

                for (var el in this.scope.aux.team_final.integrantes) {
                    let tecnico = this.scope.aux.team_final.integrantes[el];
                    data_tecnicos.push(tecnico);
                }
                let data = {
                    ott: {
                        _id: resp.data.message[0]._id,
                        numero: resp.data.message[0].numero
                    },
                    fecha: fi,
                    fecha_inicio: fi,
                    fecha_termino: ft,
                    equipo: {
                        _id: this.scope.aux.team_final._id,
                        nombre: this.scope.aux.team_final.nombre
                    },
                    tecnicos: data_tecnicos
                };


                CalendarioService.save(data)
                    .then(function (resp) {
                        self.toastr.success('Ott creada correctamente!', 'Success!', {
                            timeOut: 2000,
                            closeButton: true
                        });
                        self.location.path('/ott/');
                    });
            }).catch((err) => {
                console.log(err)
                self.toastr.error(err.data.response, 'Error', {
                    timeOut: 3500,
                    closeButton: true
                });
            });
        };

        this.scope.aux.get_casilla = function (grilla, row, casilla, casilla_index) {
            if (!casilla.disponible) {
                return false;
            }



            let clear = function () {
                for (var el_row in grilla.columnas) {
                    let columna = grilla.columnas[el_row];

                    for (var el_casilla in columna.casillas) {
                        let casilla = columna.casillas[el_casilla];
                        casilla.pseudo_disponible = true;
                    }
                }
            };

            let show_agenda = function () {
                casilla.pseudo_disponible = false;
                let dur_aux = duracion * 2;
                for (var i = casilla_index; i < (duracion * 2); i++) {
                    if (i < 48) {
                        let aux = row.casillas[i];
                        aux.pseudo_disponible = false;
                    }
                }

            };

            let ids_disponibles = casilla.teams_disponibles;
            let obj_teams = {};

            for (var _id in ids_disponibles) {
                let team = ids_disponibles[_id];
                obj_teams[team] = 0;
            }

            let duracion = this.duracion_ott.getHours();
            if (this.duracion_ott.getMinutes() > 0 && this.duracion_ott.getMinutes() <= 30) {
                duracion += 0.5;
            } else if (this.duracion_ott.getMinutes() > 30) {
                duracion += 1;
            }

            if (duracion > 0) {
                duracion = duracion / 0.5;
                for (var i = 0; i < duracion; i++) {
                    let indice = casilla_index + (i);
                    if (indice < 49) {
                        let casilla_team_disp = grilla[row].casillas[indice].teams_disponibles;

                        for (var ids_el in casilla_team_disp) {
                            let team = casilla_team_disp[ids_el];
                            obj_teams[team] += 1;
                        }
                    }
                }
            }



            let t_raw = this.teams_raw;
            let t_final = [];

            for (var el in t_raw) {
                let aux = t_raw[el];
                if (obj_teams[aux._id] == duracion) {
                    t_final.push(aux);
                }
            }

            this.teams = t_final;

            // console.log('Inicio: ' + casilla.fecha_inicio.format());
            // console.log('Fin raw: ' + casilla.fecha_termino.format());
            // console.log('Fin: ' + moment(casilla.fecha_termino.format()).add((duracion*30), 'm').format());
            // console.log(' ');
            let duracion_calc = (duracion * 30) - 1;

            this.casilla = {
                fecha_inicio: casilla.fecha_inicio.format(),
                fecha_termino: moment(casilla.fecha_inicio.format()).add(duracion_calc, 'm').format()
            };

            // clear();
            // show_agenda();
        };

        this.scope.$watch('aux.fecha_ott_agenda', (nuevo) => {
            if (nuevo) {
                this.scope.aux.agendar(true);
            }
        }, true);

        self.inAction = false;
        this.scope.aux.agendar = function (reload) {
            if (!reload) {
                reload = false;
            }
            if (self.inAction) {
                return;
            } else {
                self.inAction = true;
            }

            let validar_agenda = (data) => {
                let r = false;

                if (data.dualist.derecha.length == 0) {
                    self.toastr.error('Debe seleccionar al menos una tarea', 'Failed!', {
                        timeOut: 3000,
                        closeButton: true
                    });
                    r = true;
                }

                if (typeof data.obj_ubicacion == 'undefined') {
                    self.toastr.error('Debe seleccionar un objeto ubicación', 'Failed!', {
                        timeOut: 3000,
                        closeButton: true
                    });
                    r = true;
                } else if (Object.keys(data.obj_ubicacion).length == 0) {
                    self.toastr.error('Debe seleccionar un objeto ubicación', 'Failed!', {
                        timeOut: 3000,
                        closeButton: true
                    });
                    r = true;
                }

                if (Object.keys(data.ubicacion).length == 0) {
                    self.toastr.error('Debe seleccionar una ubicación', 'Failed!', {
                        timeOut: 3000,
                        closeButton: true
                    });
                    r = true;
                }
                return r;
            };

            if (validar_agenda(this)) {
                self.inAction = false;
                return false;
            }

            this.index = 3;
            this.dualist.options.active = false;
            this.tab_agendamiento = true;
            this.lock_equipo = true;

            this.duracion_ott = new Date(0, 0, 0, 0, 0, 0);

            if (!this.protocolos) {
                this.protocolos = [{
                    nombre: 'default',
                    listado_tareas: this.dualist.derecha
                }];
            }

            if ((Array.isArray(this.protocolos) && this.protocolos.length == 0) || self.scope.flag_new_protocolo) {
                this.protocolos = [{
                    nombre: 'default',
                    listado_tareas: this.dualist.derecha
                }];
            }

            for (var el in this.dualist.derecha) {
                let element = this.dualist.derecha[el];
                let time = new Date(element.horas_estimadas);
                time = new Date(time.valueOf() + time.getTimezoneOffset() * 60000);
                this.duracion_ott.setHours(this.duracion_ott.getHours() + time.getHours());
                this.duracion_ott.setMinutes(this.duracion_ott.getMinutes() + time.getMinutes());
            }

            let fp1_i = reload ? moment(this.fecha_ott_agenda.format()) : moment().format();
            let fp1_t = reload ? moment(this.fecha_ott_agenda.add(14, 'd')) : moment().add(14, 'd').format();

            let filter_p1 = {
                "fecha": {
                    "$gte": fp1_i,
                    "$lte": fp1_t
                }
            };

            // obtenemos los registros de las ott agendadas
            let p1 = CalendarioService.getList(filter_p1);


            // obtenemos los equipos de tecnicos
            let filterP2 = {
                proyecto: self.scope.ott.proyecto._id
            }
            let p2 = EquiposTecnicos.getAll(filterP2);


            let filter_p3 = {}

            // obtenemos la disponibilidad de equipos de tec.
            let p3 = Disponibilidad.getAll(filter_p3);


            // Promise.all([px])
            // 	.then((val)=> {
            // 	});

            $q.all([p1, p2, p3])
                .then((val) => {
                    self.inAction = false;
                    this.teams_raw = val[1].data;
                    self.agendamiento(val);
                });
        };

        this.scope.aux.cambiar_equipo = function () {
            self.scope.aux.lock_ubicacion = false;
            self.scope.ott.equipo = undefined;
            self.scope.aux.equipos = [];
            self.scope.aux.tipo_ubicaciones = [];
            self.scope.aux.ubicacion = [];

            var rellenarUbicaciones = (nuevo) => {
                let filter = {
                    'tipo.indice': 50,
                    'objeto_ubicacion._id': nuevo._id
                };
                ubicacionService.getAll(filter).then((resp, err) => {
                    if (!err) {
                        if (resp.data.message.length == 0) {
                            //alert('No existen sectores disponibles para el area seleccionada');
                            this.toastr.warning('No existen sectores disponibles para el area seleccionada', 'Ubicaciones', {
                                timeOut: 2000,
                                closeButton: true
                            });
                        }
                        let index = self.scope.aux.tipo_ubicaciones[0].nombre_interno + 's';
                        self.scope.aux.selects[index] = resp.data.message;
                    }
                });

                let data = self.scope.aux.tipo_ubicaciones;
                let arCollection = [];
                for (var el in data) {
                    let aux = data[el];
                    let str = 'aux.ubicacion.' + aux.nombre_interno;
                    if (aux.flag_equipos) {
                        arCollection.push(str);
                    }
                    self.scope.$watch(str, (nuevo) => {
                        if (nuevo !== undefined && !nuevo.tipo.flag_equipos) {
                            var filter = {
                                "tipo.indice": nuevo.tipo.indice - 1,
                                "padre._id": nuevo._id
                            }

                            let param = aux.flag_penultimo ? JSON.stringify(filter) : filter;

                            ubicacionService.getAll(param)
                                .then((resp) => {
                                    let data = resp.data.message;
                                    if (data.length == 0) {
                                        //alert("No existen ubicaciones dentro de la seleccionada");
                                        this.toastr.warning('No existen ubicaciones dentro de la seleccionada', 'Ubicaciones', {
                                            timeOut: 2000,
                                            closeButton: true
                                        });
                                    } else {
                                        let ind = data[0].tipo.nombre_interno + 's';
                                        self.scope.aux.selects[ind] = data;
                                    }
                                });
                        }
                    });
                }

                self.scope.$watchGroup(arCollection, (newValues, oldValues) => {
                    let todoOk = true;
                    for (var el in newValues) {
                        if (!newValues[el]) {
                            todoOk = false;
                        }
                    }

                    if (todoOk) {
                        let padreIds = [];

                        let ubicacion = {};

                        let ax = self.scope.aux.ubicacion;
                        let indiceMenor = 50;
                        let keyMenor = '';

                        for (var el in ax) {
                            let element = ax[el];
                            if (element.tipo.indice < 50) {
                                indiceMenor = element.tipo.indice;
                                keyMenor = el;
                            }
                        }
                        ubicacion = ax[keyMenor];

                        let proyecto = self.scope.ott.proyecto._id;
                        let key_ubicacion = 'ubicacion.' + keyMenor + '._id';

                        let filter = {
                            'tipo_equipo.sub_parte': false,
                            'proyecto._id': proyecto,
                        };
                        filter[key_ubicacion] = ubicacion._id
                        // JSON.stringify(filter)

                        inventarioService.getAll(filter)
                            .then((resp, errp) => {
                                self.scope.aux.disableEquipos = 0;
                                self.scope.aux.equipos = resp.data.message;
                            });
                    }
                });
            };

            let filter = {
                "objeto_ubicacion._id": self.scope.aux.obj_ubicacion._id
            };

            tipoUbicacionesService.getAll(filter)
                .then((resp) => {
                    let sirven = [];
                    for (var el in resp.data.message) {
                        let aux = resp.data.message[el];
                        if (!aux.flag_preventivo) {
                            sirven.push(aux);
                        } else {
                            sirven.push(aux);
                            break;
                        }
                    }
                    self.scope.aux.tipo_ubicaciones = resp.data.message;
                    rellenarUbicaciones(self.scope.aux.obj_ubicacion);
                });
        };

        this.scope.esRequerido = (element) => {
            let result = true;
            if (typeof this.scope.ott !== 'undefined' && this.scope.ott != null) {
                let proyecto = this.scope.ott.proyecto;
                if (typeof proyecto !== "undefined" && proyecto != null) {
                    if (typeof proyecto.no_requeridos !== "undefined" && proyecto.no_requeridos != null) {
                        if (typeof proyecto.no_requeridos.ott !== "undefined" && proyecto.no_requeridos.ott != null) {
                            result = proyecto.no_requeridos.ott.indexOf(element) == -1;
                        }
                    }
                }
            }
            return result;
        }

        this.scope.$watch('aux.tipo_equipo', (nuevo) => {
            if (this.scope.ott.tipo_ott == 'correctiva') {
                problemaCorrectivoService.getAll({ tipoequipo: this.scope.aux.tipo_equipo._id }).then((resp) => {
                    this.scope.aux.problemascorrectivos = resp.data.message;
                })
            }
        }, true);

        periodosService.getAll()
            .then((resp) => {
                this.scope.aux.periodos = resp.data.message;
            });

        this.scope.getSerialNumber = (location, position) => {
            inventarioService.getSerialNumber({ location: location, position: position, project: this.scope.ott.proyecto.nombre }).then((resp) => {
                this.scope.serial_number = resp.message;
            }, (error) => {
                console.log(error);
            });
        }
    }

    descargarExcel() {
        console.log("llamado")
        let info = this.scope.aux.query || this.scope.aux.filtros;
        let aux = JSON.parse(JSON.stringify(info));
        console.log(this.scope.aux.filtros)
        if (aux.preventiva) {
            // aux.fecha_inicio = {
            // 	$gte: aux.fecha_inicio.fecha_inicio,
            // 	$lte: aux.fecha_inicio.fecha_fin
            // }
        }

        var url = window.location;
        console.log(JSON.stringify(aux))
        console.log(aux)
        console.log(localStorage.getItem('token'))

        var urlNew = this.baseUrl + '/api/ott/excel' + '?token=' + localStorage.getItem('token') + '&string=' + JSON.stringify(aux);
        window.open(urlNew);
    };

    calcularAvance(orden) {
        let totalTareas = 0;
        let tareasTerminadas = 0;

        if (typeof orden.proyecto.no_requeridos !== 'undefined' &&
            typeof orden.proyecto.no_requeridos.ott !== 'undefined' &&
            orden.proyecto.no_requeridos.ott.indexOf('avance') > -1) {
            return '-';
        }


        for (var i = 0, len = orden.protocolo.length; i < len; i++) {
            for (var x = 0, lenTareas = orden.protocolo[i].listado_tareas.length; x < lenTareas; x++) {
                totalTareas++;
                orden.protocolo[i].listado_tareas[x].horas_estimadas = new Date(orden.protocolo[i].listado_tareas[x].horas_estimadas);
                orden.protocolo[i].listado_tareas[x].duracion = new Date(orden.protocolo[i].listado_tareas[x].duracion);
                if (!angular.isUndefined(orden.protocolo[i].listado_tareas[x].estado) &&
                    orden.protocolo[i].listado_tareas[x].estado.flag_fin) {

                    // 		orden.protocolo[i].listado_tareas[x].estado._id === "59193ba85e6379817662e98f"){
                    tareasTerminadas++;
                }

            }
        }
        return parseInt((tareasTerminadas * 100) / totalTareas) + " %";
    };

    getUbicacion(ubicacion, proyecto) {
        if (ubicacion.posicion !== undefined) {
            if (proyecto.abreviacion == 'AVO1' || proyecto.abreviacion == 'CANOPSA') {
                if (ubicacion.posicion) {
                    return ubicacion.posicion.descripcion
                } else {
                    return ubicacion.tramo.nombre;
                }
            } else {
                return ubicacion.posicion.nombre
            }
        } else if (ubicacion.equipo !== undefined) {
            return ubicacion.equipo.nombre
        } else {
            let resp = '';
            let ind = 0;
            for (var index in ubicacion) {
                let element = ubicacion[index].nombre;
                resp += element;
                if (ind < (Object.keys(ubicacion).length - 1)) {
                    resp += '/';
                }
                ind++;
            }
            return resp;
        }
    };

    getUbicacionAvo(ubicacion, proyecto) {
        if (ubicacion.posicion !== undefined) {
            if (proyecto.abreviacion == 'AVO1' || proyecto.abreviacion == 'CANOPSA') {
                if (ubicacion.posicion) {
                    return ubicacion.posicion.nombre;
                } else {
                    return ubicacion.tramo.nombre;
                }
            } else {
                return ubicacion.posicion.nombre
            }
        } else {
            let resp = '';
            let ind = 0;
            for (var index in ubicacion) {
                let element = ubicacion[index].nombre;
                resp += element;
                if (ind < (Object.keys(ubicacion).length - 1)) {
                    resp += '/';
                }
                ind++;
            }
            return resp;
        }
    }

    getTipo(orden) {
        let tipo = "Preventiva"
        if (typeof orden.incidencia != 'undefined') {
            tipo = "Correctiva";
        }
        return tipo;
    };

    actualizarTarea(ottService, info, ott, tarea) {
        // console.log(tarea);
        var self = this.scope;
        var granSelf = this;
        let avance = this.calcularAvance(this.scope.ott).split(" ")[0];
        let flag_avance = (avance == "100" && !self.isTecnico) ? true : false;
        let templateModal = `
			<div class="modal-content">
				<div class="modal-header">
					<h4 style="text-align:center;" class="modal-title">Actualizar Tarea</h4>
				</div>
				<div class="modal-body">
					<div class="form-horizontal form-label-left">
						<div class="row" ng-if="ctr.tarea.estado.flag_fin == true">
							<div class="col-md-12 col-sm-12 col-xs-12" >
								<div class="form-group">
									<label class="control-label col-md-3 col-sm-12 col-xs-12" for="first-name">Duracion: <span class="required">(horas)</span>
									</label>
									<div class="col-md-9 col-sm-12 col-xs-12">
										<input type="time" ng-model="ctr.duracion" class="form-control" ng-model-options="{timezone:'UTC'}">
									</div>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-12 col-sm-12 col-xs-12" >
								<div class="form-group">
									<label class="control-label col-md-3 col-sm-12 col-xs-12" for="first-name">Comentario: <span class="required">*</span>
									</label>
									<div class="col-md-9 col-sm-12 col-xs-12">
										<textarea style="width:100%;"
					              			class="resizable_textarea form-control"
					              			placeholder="Ingrese Observación"
					              			ng-model="ctr.observacion">
					              		</textarea>
									</div>
								</div>
							</div>
						</div>
						<div class="row" ng-if="ctr.flag_fin == true">
							<div class="col-md-10 col-sm-10 col-xs-10" >
								<div class="form-group">
									<label class="control-label col-md-3 col-sm-12 col-xs-12" for="first-name">Cerrar Ott:
									</label>
									<div class="col-md-9 col-sm-12 col-xs-12">
										<!-- <input type="text" ng-model="ctr.duracion" class="form-control"> -->
										<select class="form-control" ng-model="ctr.flag">
										 	<option value="true">Si</option>
											<option value="false">No</option>
										</select>
									</div>
								</div>
							</div>
						</div>
					</div>
			    </div>
			    <div class="modal-footer">
					<div class="btn btn-success pull-right" ng-click="ctr.save()">Guardar</div>
			    </div>
			</div>
		`;
        // 	tareasService, herramientasService, riesgoService
        let modal = this.modal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            template: templateModal,
            controller: function (ottService, flag_fin) {
                var vm = this;
                vm.tarea = tarea;
                vm.observacion = '';
                vm.duracion = tarea.horas_estimadas;
                vm.flag_fin = flag_fin;
                this.save = () => {
                    vm.tarea.duracion = vm.duracion;
                    let data = {
                        // usuario	: localStorage.getItem('usuario'),
                        usuario: info.get('nombre') + ' ' + info.get('apellido'),
                        "ott": {
                            "_id": ott
                        },
                        tarea: vm.tarea,
                        observacion: vm.observacion,
                        flag: flag_fin
                    };
                    modal.close(data);
                }
            },
            controllerAs: 'ctr',
            size: 'md',
            resolve: {
                ottService: function () {
                    return ottService;
                },
                flag_fin: function () {
                    return flag_avance;
                }
            }
        });

        modal.result.then((resp_in) => {
            let data = {
                usuario: resp_in.usuario,
                "ott": resp_in.ott,
                tarea: resp_in.tarea
            };

            ottService.actualizarTarea(data)
                .then((respTarea) => {
                    self.ott.protocolo[0].listado_tareas = respTarea.data.tareas;
                    self.aux.avance = granSelf.calcularAvance(self.ott);
                    let observacion = [{
                        text: "[Tarea : " + resp_in.tarea.nombre + " (" + resp_in.tarea.estado.nombre + ")] " + resp_in.observacion,
                        usuario: resp_in.usuario,
                        fecha: new Date(),
                        "ott": resp_in.ott
                    }];

                    if (resp_in.flag) {
                        observacion.push({
                            text: "[Ott : cambio de estado a " + resp_in.tarea.estado.nombre + ")]",
                            usuario: resp_in.usuario,
                            fecha: new Date(),
                            "ott": resp_in.ott
                        });
                    }

                    ottService.agregarObservacion(observacion)
                        .then((resp) => {

                            if (resp_in.flag) {
                                this.cerrarOtt(ottService);
                            } else {
                                //window.location.reload();
                                self.ott.observaciones = resp.data.observaciones;
                            }
                        });
                });
        }, (exit) => {
            console.log('modal close');
        });
    };

    cerrarOtt(ottService) {
        let data = {
            _id: this.scope.ott._id
        };

        ottService.cerrarOtt(data)
            .then((resp) => {
                // console.log('reload');
                //window.location.reload();
                this.location.path('/ott/');
            });
    };

    finalizarOtt(ottService, info) {

        let templateModal = `
			<div class="modal-content">
				<div class="modal-header">
					<h4 style="text-align:center;" class="modal-title">Agregar Comentario</h4>
				</div>
				<div class="modal-body">
					<div class="form-horizontal form-label-left">
						<div class="row">
							<div class="col-md-12 col-sm-12 col-xs-12">
								<div class="form-group">
									<label class="control-label col-md-3 col-sm-3 col-xs-3" for="first-name">Comentario: <span class="required">*</span>
									</label>
									<div class="col-md-9 col-sm-9 col-xs-9">
										<textarea
											style="width:100%;"
					              			class="resizable_textarea form-control"
					              			placeholder="Ingrese Observación"
					              			ng-model="ctr.observacion">
					              		</textarea>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<div class="btn btn-success pull-right" ng-click="ctr.save()">Guardar</div>
				</div>
			</div>
		`;
        let modal = this.modal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            template: templateModal,
            controller: function () {
                var vm = this;
                vm.observacion = '';
                vm.duracion = 0;
                this.save = () => {
                    let data = {
                        // usuario	: localStorage.getItem('usuario'),
                        usuario: info.get('nombre') + ' ' + info.get('apellido'),
                        observacion: vm.observacion
                    };
                    modal.close(data);
                }
            },
            controllerAs: 'ctr',
            size: 'md'
        });

        modal.result.then((resp) => {
            let flag = (arguments[arguments.length - 1]) ? 'Aceptada' : 'Rechazada';

            let observacion = {
                text: "[Ott " + flag + "] " + resp.observacion,
                usuario: resp.usuario,
                fecha: new Date(),
                "ott": {
                    _id: this.scope.ott._id
                }
            };
            ottService.agregarObservacion(observacion)
                .then((resp) => {
                    //this.location.path('/ott');
                    let data = {
                        _id: this.scope.ott._id,
                        proyecto: this.scope.ott.proyecto._id,
                        aceptada: arguments[arguments.length - 1]
                    };

                    ottService.finalizarOtt(data)
                        .then((resp) => {
                            this.location.path('/ott/');
                        });
                });
        }, (exit) => {
            console.log('modal close');
        });

    };

    confirmarCierreOtt(ottService, ott) {

        let templateModal = `
			    <div class="modal-content">
			      <div class="modal-header">
			        <h4 class="modal-title" id="myModalLabel">Tareas Finalizadas</h4>
			      </div>
			      <div class="modal-body">
                		¿Desea Cerrar la ott?
			      </div>
			      <div class="modal-footer">
			        <button type="button" class="btn btn-default" ng-click="ctr.no()">NO</button>
			        <button type="button" class="btn btn-primary" ng-click="ctr.si()">SI</button>
			      </div>
			    </div>
		`;

        let modal = this.modal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            template: templateModal,
            controller: function () {
                var vm = this;

                this.no = () => {
                    let data = {
                        cerrar: false
                    };
                    modal.close(data);
                }

                this.si = () => {
                    let data = {
                        cerrar: true
                    };
                    modal.close(data);
                }
            },
            controllerAs: 'ctr',
            size: 'md'
        });

        modal.result.then((resp) => {
            if (resp.cerrar) {
                let data = {
                    _id: this.scope.ott._id
                };

                ottService.cerrarOtt(data)
                    .then((resp) => {
                        window.location.reload();
                    });
            }

        }, (exit) => {
            console.log('modal close');
        });

    }

    agendamiento(info) {

        let agendas = info[0].data.message;
        let team = info[1].data;
        let disp_t = info[2].data;
        let self = this;

        let grilla_base = function () {
            let dias = 14;
            let casillas_x_dia = 48;
            let grilla = {
                columnas: [],
                data: {
                    dias: dias,
                    casillas: casillas_x_dia
                }
            };

            for (var i = 0; i < dias; i++) {
                let columna = {
                    casillas: [],
                    data: {}
                };

                // let fecha_dia = moment();
                let fecha_dia;

                if (self.scope.aux.fecha_ott_agenda) {
                    fecha_dia = moment(self.scope.aux.fecha_ott_agenda.format());
                } else {
                    fecha_dia = moment();
                }

                fecha_dia.add(i, 'days');
                columna.data.fecha = fecha_dia;
                columna.data.fecha_string = fecha_dia.format('DD/MM');
                for (var j = 0; j < casillas_x_dia; j++) {

                    let fecha1 = moment(fecha_dia.format());
                    let fecha2 = moment(fecha_dia.format());

                    let hour = Math.floor(j / 2);
                    let fi = fecha1.set({
                        hour: hour,
                        minute: (j % 2 == 0) ? 0 : 30,
                        second: 0
                    });


                    let ff = fecha2.set({
                        hour: hour,
                        minute: (j % 2) == 0 ? 29 : 59,
                        second: 0
                    });

                    let data_push = {
                        disponible: true,
                        pseudo_disponible: true,
                        fecha_inicio: fi,
                        fecha_termino: ff,
                        cantidad_ott: 0,
                        cantidad_teams_ocupados: 0,
                        teams_disponibles: []
                    };

                    if (i == 0) {
                        data_push.h_i = fi.format('HH:mm');
                        data_push.h_f = ff.format('HH:mm');
                    }
                    columna.casillas.push(data_push);
                }
                // console.log(fecha_dia.date());
                grilla.columnas.push(columna);
            }

            return grilla;
        };

        let grilla = grilla_base();

        grilla = this.insertOttGrilla(grilla, agendas, team, disp_t);
        this.scope.aux.grilla = grilla;
    }

    insertOttGrilla(grilla, agenda, team, disp_t) {
        // Cada array dentro de la matrix estan asociados a un dia de la grilla
        // y contiene las ott para ese dia
        let matrix_ott = [];
        let matrix_team = {};
        let equipos = {};
        let equipos_ids = [];
        let duracionOtt = this.scope.aux.duracion_ott.getHours();
        if (this.scope.aux.duracion_ott.getMinutes() > 0 && this.scope.aux.duracion_ott.getMinutes() <= 30) {
            duracionOtt += 0.5;
        } else if (this.scope.aux.duracion_ott.getMinutes() > 30) {
            duracionOtt += 1;
        }
        let duracion = (duracionOtt * 2) - 1;

        // falta diferencias la disponibilidad de tecnicos
        // en cuanto a ott preventivas con los teams de turnos

        // convertimos las fechas a objetos
        for (var el in agenda) {
            let aux = agenda[el];
            aux.fecha_inicio = moment(aux.fecha_inicio);
            aux.fecha_termino = moment(aux.fecha_termino);
        }

        //recoremos los teams
        // y los pasamos a un objeto con los ids de los teams
        for (var el in team) {
            let equipo = team[el];
            equipos[equipo._id] = {
                _id: equipo._id,
                nombre: equipo.nombre,
                fechas_presentes: [],
                disponibilidad: {}
            }
        }

        equipos_ids = Object.keys(equipos);

        equipos.cantidad = Object.keys(equipos).length;

        // asociamos la disponibilidad a la MATRIX_TEAM
        // esta tiene la info de cuando los teams no estan disp

        disp_t.message.forEach(function (aux) {
            let fecha = new Date(aux.fecha_inicio.substr(0, 9));
            let day = "" + fecha.getDate();
            if (day.length === 1) {
                day = '0' + day;
            }
            let month = "" + (fecha.getMonth() + 1);
            if (month.length === 1) {
                month = '0' + month;
            }

            let fecha_key = day + '/' + month;
            // si no existian registros para la fecha
            if (!matrix_team[fecha_key]) {

                matrix_team[fecha_key] = {
                    no_disponible: []
                };

                let m = matrix_team[fecha_key];
                // console.log(m);
                m.no_disponible.push({
                    fecha_inicio: moment(aux.fecha_inicio),
                    fecha_termino: moment(aux.fecha_termino),
                    flag_turno: aux.flag_turno,
                    //flag_no_disponible: flag_no_disponible,
                    id_team: aux.id_equipo
                });


            } else {
                // si existen el team en la matrix
                let m = matrix_team[fecha_key].no_disponible;

                m.push({
                    fecha_inicio: moment(aux.fecha_inicio),
                    fecha_termino: moment(aux.fecha_termino),
                    flag_turno: aux.flag_turno,
                    id_team: aux.id_equipo
                });
            }

        });


        // recorremos los dias y le agregamos un array por cada uno
        // a la matrix_ott
        for (var el in grilla.columnas) {
            let aux_date = grilla.columnas[el].data.fecha.date();
            for (var inner_el in agenda) {
                let ott_aux = agenda[inner_el];
                let fecha_i = new Date(ott_aux.fecha_inicio);
                let fecha_t = new Date(ott_aux.fecha_termino);
                if (fecha_i.getDate() == aux_date ||
                    fecha_t.getDate() == aux_date) {
                    if (!matrix_ott[el]) {
                        matrix_ott[el] = [];
                    }
                    matrix_ott[el].push(ott_aux);
                }
            }
        }


        // Le agregamos a las casillas +1 por cada ott
        for (var el in grilla.columnas) {

            let aux = grilla.columnas[el];
            let casillas = aux['casillas'];
            let data = aux['data'];

            for (var ott_index in matrix_ott[el]) {
                let ott = matrix_ott[el][ott_index];

                if (!matrix_team[aux.data.fecha_string]) {
                    matrix_team[aux.data.fecha_string] = {
                        no_disponible: []
                    };

                    matrix_team[aux.data.fecha_string].no_disponible.push({
                        fecha_inicio: moment(ott.fecha_inicio),
                        fecha_termino: moment(ott.fecha_termino),
                        id_team: ott.equipo._id
                    });
                } else {
                    matrix_team[aux.data.fecha_string].no_disponible.push({
                        fecha_inicio: moment(ott.fecha_inicio),
                        fecha_termino: moment(ott.fecha_termino),
                        id_team: ott.equipo._id
                    });
                }
            }
            // recorremos las casillas de un dia
            for (var casilla_el in casillas) {
                let casilla = casillas[casilla_el];

                // recorremos las ott asociadas al dia
                for (var index in matrix_ott[el]) {
                    let ott_x_dia = matrix_ott[el][index];

                    let ott_i = ott_x_dia.fecha_inicio;
                    let ott_t = ott_x_dia.fecha_termino;
                    let casilla_i = casilla.fecha_inicio;
                    let casilla_t = casilla.fecha_termino;

                    let inicio = ott_i.isSameOrBefore(casilla_i);
                    let termino = ott_t.isSameOrAfter(casilla_t);

                    if (inicio && termino) {
                        casilla.cantidad_ott += 1;
                    }
                }
            }
        }

        // recorremos la grilla y le sumamos los teams ocupados
        for (var el in grilla.columnas) {
            let columna = grilla.columnas[el];
            let teams = matrix_team[columna.data.fecha_string];

            if (teams) {
                for (var inner_el in columna.casillas) {
                    let casilla = columna.casillas[inner_el]

                    let teams_ocupados = [];
                    for (var el_disp in teams.no_disponible) {
                        let disp = teams.no_disponible[el_disp];

                        if (casilla.fecha_inicio.isBetween(disp.fecha_inicio, disp.fecha_termino, null, '[]')) {
                            casilla.cantidad_teams_ocupados += 1;
                            teams_ocupados.push(disp.id_team);
                        }
                    }

                    casilla.teams_disponibles = _.difference(equipos_ids, teams_ocupados);
                }
            } else {
                for (var inner_el in columna.casillas) {
                    let casilla = columna.casillas[inner_el];
                    casilla.teams_disponibles = equipos_ids;
                }
            }
        }

        // aplicamos todas las validaciones
        for (var el in grilla.columnas) {
            let columna = grilla.columnas[el];
            // let teams   = matrix_team[columna.data.fecha_string];

            for (var inner_el in columna.casillas) {
                let casilla = columna.casillas[inner_el];

                if (casilla.cantidad_ott == equipos.cantidad) {
                    casilla.disponible = false;
                }

                if (casilla.cantidad_teams_ocupados == equipos.cantidad) {
                    casilla.disponible = false;
                }
            }
        }

        // comprobamos la duracion de la ott con la grilla
        for (var el in grilla.columnas) {
            let columna = grilla.columnas[el];

            // recorremos las casillas
            for (var inner_el in columna.casillas) {
                let casilla = columna.casillas[inner_el];
                if (!casilla.disponible) {
                    continue;
                }

                let comp = {
                    disp: 0,
                    ndisp: 0
                };

                // recorremos los teams disponibles
                for (var el_id in casilla.teams_disponibles) {
                    let id = casilla.teams_disponibles[el_id];
                    let disponible = true;


                    // recorremos las casillas hacia delante
                    for (var i = 0; i < duracion; i++) {
                        let index = parseInt(inner_el) + (i + 1);

                        if (index < grilla.data.casillas) {

                            if (columna.casillas[index].teams_disponibles.indexOf(id) < 0) {
                                disponible = false;
                            }
                            if (!disponible) {
                                break;
                            }
                        } else {
                            let virtual_index = parseInt(el) + 1;
                            let virtual_inner_index = index - 48;

                            if (virtual_index < 14) {
                                if (grilla.columnas[virtual_index].casillas[virtual_inner_index].teams_disponibles.indexOf(id) < 0) {
                                    disponible = false;
                                }
                                if (!disponible) {
                                    break;
                                }
                            }
                        }
                    }

                    if (disponible) {
                        comp.disp += 1;
                    } else {
                        comp.ndisp += 1;
                    }
                }

                if (comp.disp < comp.ndisp && comp.disp == 0) {
                    casilla.disponible = false;
                }
            }
        }

        return grilla;
    }



    guardarTareas(toastr, ottService, info, causaFallaCorrectivaService, ott, protocolo, proyecto, tipo, ottData) {
        var self = this.scope;
        let isTecnico = self.isTecnico;
        var isAllOk = true;
        protocolo.listado_tareas.forEach(function (tarea) {

            if (tarea.esRequerida
                && (typeof tarea.observacion == 'undefined' || tarea.observacion == '')) {
                if (typeof tarea.estado.index === 'undefined') {
                    tarea.isErrorEstado = true;
                    isAllOk = false;
                } else if (tarea.estado.index !== 3) {
                    tarea.isErrorObservacion = true;
                    isAllOk = false;
                } else {
                    tarea.isErrorObservacion = false;
                }

            } else {
                tarea.isErrorObservacion = false;
            }

            if (tarea.esRequerida
                && (typeof tarea.estado.index === 'undefined')) {
                tarea.isErrorEstado = true;
                isAllOk = false;
            } else {
                tarea.isErrorEstado = false;
            }
        });
        if (isAllOk) {
            let templateModal = `
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 style="text-align:center;" class="modal-title">Actualizar Tareas</h4>
                    </div>
                    <div class="modal-body">
                        <div class="form-horizontal form-label-left">
                            <div class="row mt-2">
                                <div class="col-md-12 col-sm-12 col-xs-12" >
                                    <div class="form-group">
                                    
                                        <label ng-if="ctr.correctiva == true" class="control-label col-md-4 col-sm-12 col-xs-12" for="first-name">Accion Correctiva: <span class="required">*</span>
                                        </label>
                                        <label ng-if="ctr.correctiva == false" class="control-label col-md-4 col-sm-12 col-xs-12" for="first-name">Observación: <span class="required">*</span>
                                        </label>
                                        <div class="col-md-8 col-sm-12 col-xs-12">
                                            <textarea style="width:100%;"
                                                class="resizable_textarea form-control"
                                                placeholder="Ingrese Texto"
                                                ng-model="ctr.observacion">
                                            </textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-md-4 col-sm-4 col-xs-4">              
                                    <label class="control-label">Remoto: <span class="required">*</span>
                                    </label>
                                </div>
                                <div id="type" class="btn-group col-md-8 col-sm-8 col-xs-8" data-toggle="buttons">
                                    <label class="btn "
                                        ng-class="{'btn-default': ctr.remoto != 'si', 'btn-primary': ctr.remoto == 'si'}"
                                        data-toggle-class="btn-primary" data-toggle-passive-class="btn-default">
                                        <input type="radio" ng-model="ctr.remoto" value="si"> &nbsp; Sí &nbsp;
                                    </label>
                                    <label class="btn btn-default"
                                        ng-class="{'btn-default': ctr.remoto != 'no', 'btn-primary': ctr.remoto == 'no'}"
                                        data-toggle-class="btn-primary" data-toggle-passive-class="btn-default">
                                        <input type="radio" ng-model="ctr.remoto" value="no"> &nbsp; No &nbsp;
                                    </label>
                                </div>
                                <br>
                            </div>
                            <div class="row mb-2">
                                <div class="col-md-4 col-sm-4 col-xs-4">              
                                    <label class="control-label">Realizo corrección: <span class="required">*</span>
                                    </label>
                                </div>
                                <div id="type" class="btn-group col-md-8 col-sm-8 col-xs-8" data-toggle="buttons">
                                    <label class="btn "
                                        ng-class="{'btn-default': ctr.work_on_ground != 'si', 'btn-primary': ctr.work_on_ground == 'si'}"
                                        data-toggle-class="btn-primary" data-toggle-passive-class="btn-default">
                                        <input type="radio" ng-model="ctr.work_on_ground" value="si"> &nbsp; Sí &nbsp;
                                    </label>
                                    <label class="btn btn-default"
                                        ng-class="{'btn-default': ctr.work_on_ground != 'no', 'btn-primary': ctr.work_on_ground == 'no'}"
                                        data-toggle-class="btn-primary" data-toggle-passive-class="btn-default">
                                        <input type="radio" ng-model="ctr.work_on_ground" value="no"> &nbsp; No &nbsp;
                                    </label>
                                </div>
                                <br>
                            </div>
                            <div class="row" ng-if="ctr.remoto == 'no'"> 
                                <div class="col-md-4 col-sm-4 col-xs-4">
                                    <label class="control-label" for="first-name">Llegada terreno: <span class="required">*</span>
                                    </label>
                                </div>
                                <div class="col-md-8 col-sm-8 col-xs-8">
                                    <div>
                                        <div ng-if="ctr.isTecnico == true" class="form-control" required
                                            ng-model="ctr.protocolo.fecha_llegada"
                                            moment-picker="ctr.aux.fecha_llegada"
                                             format="DD-MM-YYYY, HH:mm"
                                             start-view="day"
                                             min-view="day"
                                             max-view="minute"
                                             selectable="ctr.onlyToday(date, view)">
                                            {{ctr.aux.fecha_llegada}} 
                                        </div>
                                        <div ng-if="ctr.isTecnico == false" class="form-control" required
                                            ng-model="ctr.protocolo.fecha_llegada"
                                            format="DD-MM-YYYY, HH:mm"
                                            moment-picker="ctr.aux.fecha_llegada">
                                            {{ctr.aux.fecha_llegada}} 
                                        </div>
                                    </div>
                                </div>  
                            </div>
                            <div class="row" ng-if="(ctr.remoto == 'no' && ctr.work_on_ground == 'si') || (ctr.remoto == 'si')">
                                <div class="col-md-4 col-sm-4 col-xs-4">
                                    <label class="control-label" ng-if="ctr.remoto == 'no'" for="first-name">Inicio correctivo: <span class="required">*</span>
                                    </label>
                                    <label class="control-label" ng-if="ctr.remoto == 'si'" for="first-name">Inicio incidencia: <span class="required">*</span>
                                    </label>
                                </div>
                               <div class="col-md-8 col-sm-8 col-xs-8">
                                    <div>
                                        <div ng-if="ctr.isTecnico == true" class="form-control" required
                                            ng-model="ctr.protocolo.fecha_inicio"
                                            moment-picker="ctr.aux.fecha_inicio"
                                             format="DD-MM-YYYY, HH:mm"
                                             start-view="day"
                                             min-view="day"
                                             max-view="minute"
                                             selectable="ctr.onlyToday(date, view)">
                                            {{ctr.aux.fecha_inicio}} 
                                        </div>
                                        <div ng-if="ctr.isTecnico == false" class="form-control" required
                                            ng-model="ctr.protocolo.fecha_inicio"
                                            format="DD-MM-YYYY, HH:mm"
                                            moment-picker="ctr.aux.fecha_inicio">
                                            {{ctr.aux.fecha_inicio}} 
                                        </div>
                                    </div>
                                </div>  
                            </div>
                            <div class="row" ng-if="(ctr.remoto == 'no' && ctr.work_on_ground == 'si') || (ctr.remoto == 'si')">
                                <div class="col-md-4 col-sm-4 col-xs-4">
                                    <label class="control-label" ng-if="ctr.remoto == 'no'" for="first-name">Termino correctivo: <span class="required">*</span>
                                    </label>
                                    <label class="control-label" ng-if="ctr.remoto == 'si'" for="first-name">Termino incidencia: <span class="required">*</span>
                                    </label>
                                </div>
                                <div class="col-md-8 col-sm-8 col-xs-8">
                                    <div>
                                     <div ng-if="ctr.isTecnico ==true" class="form-control" required
                                            ng-model="ctr.protocolo.fecha_fin"
                                            format="DD-MM-YYYY, HH:mm"
                                            moment-picker="ctr.aux.fecha_fin"
                                            start-view="day"
                                             min-view="day"
                                             max-view="minute"
                                             selectable="ctr.onlyToday(date, view)">
                                            {{ctr.aux.fecha_fin}} 
                                        </div>
                                        <div ng-if="ctr.isTecnico == false" class="form-control" required
                                            ng-model="ctr.protocolo.fecha_fin"
                                            format="DD-MM-YYYY, HH:mm"
                                            moment-picker="ctr.aux.fecha_fin">
                                            {{ctr.aux.fecha_fin}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row" ng-if="ctr.remoto == 'no'">
                                    <div class="col-md-4 col-sm-4 col-xs-4">
                                        <label class="control-label" for="first-name">Salida terreno: <span class="required">*</span>
                                        </label>
                                    </div>
                                    <div class="col-md-8 col-sm-8 col-xs-8">
                                        <div>
                                         <div ng-if="ctr.isTecnico ==true" class="form-control" required
                                            ng-model="ctr.protocolo.fecha_salida"
                                            format="DD-MM-YYYY, HH:mm"
                                            moment-picker="ctr.aux.fecha_salida"
                                            start-view="day"
                                             min-view="day"
                                             max-view="minute"
                                             selectable="ctr.onlyToday(date, view)">
                                            {{ctr.aux.fecha_salida}} 
                                        </div>
                                            <div ng-if="ctr.isTecnico ==false" class="form-control" required
                                                ng-model="ctr.protocolo.fecha_salida"
                                                format="DD-MM-YYYY, HH:mm"
                                                moment-picker="ctr.aux.fecha_salida">
                                                {{ctr.aux.fecha_salida}}
                                            </div>
                                        </div>
                                    </div>
                            </div>
                            <div class="row" ng-if="ctr.correctiva">			
                                <div class="col-md-4 col-sm-4 col-xs-4">				
                                    <label class="control-label">Causa de Falla <span class="required">*</span>
                                    </label>
                                </div>	
                                </label>
                                <div class="col-md-8 col-sm-8 col-xs-8">
                                    <select class="form-control" ng-model="ctr.protocolo.causa_falla"
                                    ng-options="causa as causa.nombre for causa in ctr.causasFalla | orderBy:'nombre' track by causa._id">
                                </select>
                                    </select>
                                </div>
                            </div>
                            <div class="row" ng-show="ctr.correctiva == true && ctr.protocolo.causa_falla.nombre == 'OTRO'">                                
                                <div class="col-sm-3">              
                                    <label class="control-label col-md-7 col-sm-4 col-xs-12">Otra causa <span class="required">*</span>
                                    </label>
                                </div>
                                <div class="col-md-6 col-sm-6 col-xs-12">
                                    <input style="text" ng-model="ctr.protocolo.otra_causa_falla">
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-md-4 col-sm-4 col-xs-4">				
                                    <label class="control-label ">Segregación: <span class="required">*</span>
                                    </label>
                                </div>
                                <div class="col-md-8 col-sm-8 col-xs-8">
                                    <div id="type" class="btn-group" data-toggle="buttons">
                                        <label class="btn "
                                            ng-class="{'btn-default': ctr.protocolo.segregacion != 'si', 'btn-primary': ctr.protocolo.segregacion == 'si'}"
                                            data-toggle-class="btn-primary" data-toggle-passive-class="btn-default">
                                            <input type="radio" ng-model="ctr.protocolo.segregacion" value="si"> &nbsp; Sí &nbsp;
                                        </label>
                                        <label class="btn btn-default"
                                            ng-class="{'btn-default': ctr.protocolo.segregacion != 'no', 'btn-primary': ctr.protocolo.segregacion == 'no'}"
                                            data-toggle-class="btn-primary" data-toggle-passive-class="btn-default">
                                            <input type="radio" ng-model="ctr.protocolo.segregacion" value="no"> &nbsp; No &nbsp;
                                        </label>
                                    </div>
                                    <br>
                                </div>	        
                            </div>
                            <div class="row" ng-if="ctr.protocolo.segregacion == 'si'">			
                                <div class="col-md-4 col-sm-4 col-xs-4">				
                                    <label class="control-label col-md-12 col-sm-4 col-xs-12">Tipo Segregación: 
                                    </label>
                                </div>	
                                </label>
                                <div class="col-md-7 col-sm-7 col-xs-7">
                                    <select class="form-control" ng-model="ctr.protocolo.tipo_segregacion">
                                        <option value="local"> Local </option>
                                        <option value="expresa"> Expresa </option>
                                        <option value="mediana"> Mediana </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div class="btn btn-success pull-right" ng-click="ctr.save()">Guardar</div>
                    </div>
                </div>
            `;
            let modal = this.modal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                template: templateModal,
                controller: function (causaFallaCorrectivaService) {
                    var vm = this;
                    vm.isTecnico = isTecnico;
                    vm.aux = {};
                    vm.ott = ott;
                    vm.protocolo = protocolo;
                    vm.remoto = (ottData.remoto !== undefined && ottData.remoto !== null)
                    ? (ottData.remoto ? 'si' : 'no')
                    : 'no';

                    
                    vm.work_on_ground = (ottData.work_on_ground !== undefined && ottData.work_on_ground !== null)
                    ? (ottData.work_on_ground ? 'si' : 'no')
                    :'si';
                    vm.causaFallaCorrectivaService = causaFallaCorrectivaService;
                    vm.aux.fecha_llegada = protocolo.fecha_llegada ? (moment(protocolo.fecha_llegada).isValid() ? moment(protocolo.fecha_llegada).format('DD-MM-YYYY, HH:mm') : protocolo.fecha_llegada) : '';
                    vm.aux.fecha_salida = protocolo.fecha_salida ? (moment(protocolo.fecha_salida).isValid() ? moment(protocolo.fecha_salida).format('DD-MM-YYYY, HH:mm') : protocolo.fecha_salida) : '';
                    vm.aux.fecha_inicio = protocolo.fecha_inicio ? (moment(protocolo.fecha_inicio).isValid() ? moment(protocolo.fecha_inicio).format('DD-MM-YYYY, HH:mm') : protocolo.fecha_inicio) : '';
                    vm.aux.fecha_fin = protocolo.fecha_fin ? (moment(protocolo.fecha_fin).isValid() ? moment(protocolo.fecha_fin).format('DD-MM-YYYY, HH:mm') : protocolo.fecha_fin) : '';
                    vm.proyecto = proyecto;
                    vm.observacion = "";


                    vm.onlyToday = function (date, view) {
                        return view === 'day'
                            ? moment(date).isSame(moment(), 'day')  
                            : true; 
                    };
                 
                    vm.correctiva = tipo;
                    if (vm.correctiva) {
                        vm.observacion = protocolo.accion_correctiva;
                    }

                    let filter = {};
                    // filter = { tipoequipo: ottData.calendario.equipo._id }
                    // if (vm.ott.) {
                    // console.log("PROTOCOLO");
                    // console.log(vm.protocolo.tipo_equipo);
                    // console.log(typeof vm.protocolo.tipo_equipo);
                    // console.log(vm.protocolo);
                    if (vm.protocolo.tipo_equipo) {
                        filter = { tipoequipo: vm.protocolo.tipo_equipo._id }
                    }
                    // }
                    // console.log(ottData)
                    vm.causaFallaCorrectivaService.getAll(filter).then((resp) => {
                        vm.causasFalla = resp.data.message;
                        console.log(vm.causasFalla)
                    });
                    this.save = () => {

                        const fechaStr = vm.aux.fecha_inicio;

                        if (moment.isMoment(fechaStr)) {
                        
                        vm.protocolo.fecha_inicio = fechaStr.toDate().toISOString();
                        } else if (fechaStr instanceof Date) {
                       
                        vm.protocolo.fecha_inicio = fechaStr.toISOString();
                        } else {
                       
                        const momentObj = moment(fechaStr, 'DD-MM-YYYY HH:mm', true);
                        if (momentObj.isValid()) {
                            vm.protocolo.fecha_inicio = momentObj.toDate().toISOString();
                        } else {
                            
                        }
                        }

                        const fechaStr1 = vm.aux.fecha_fin;

                        if (moment.isMoment(fechaStr1)) {
                        vm.protocolo.fecha_fin = fechaStr1.toDate().toISOString();
                        } else if (fechaStr1 instanceof Date) {
                        vm.protocolo.fecha_fin = fechaStr1.toISOString();
                        } else {
                        const momentObj1 = moment(fechaStr1, 'DD-MM-YYYY HH:mm', true);
                        if (momentObj1.isValid()) {
                            vm.protocolo.fecha_fin = momentObj1.toDate().toISOString();
                        } else {
                        
                        }
                        }

                        if (typeof vm.observacion === 'undefined' || vm.observacion === '') {
                            toastr.error('Favor ingresar una observacion', 'Error!', {
                                timeOut: 2000,
                                closeButton: true
                            });
                            return;
                        } else if (vm.correctiva) {
                            vm.protocolo.accion_correctiva = vm.observacion;
                        }
                       
                        if (vm.remoto === 'si') {
                            vm.protocolo.fecha_llegada = null;
                            vm.protocolo.fecha_salida = null;
                        }else{
                            if (typeof vm.protocolo.fecha_llegada === 'undefined' || vm.fecha_llegada === '' || vm.protocolo.fecha_llegada === null) {
                                toastr.error('Favor ingresar las fechas solicitadas', 'Error!', {
                                    timeOut: 2000,
                                    closeButton: true
                                });
                                return;
                            }

                            if (typeof vm.protocolo.fecha_salida === 'undefined' || vm.fecha_salida === '' || vm.fecha_salida === null) {
                                toastr.error('Favor ingresar las fechas solicitadas', 'Error!', {
                                    timeOut: 2000,
                                    closeButton: true
                                });
                                return;
                            }
                        }

                        if (vm.remoto === 'no' && vm.work_on_ground === 'no') {
                            vm.protocolo.fecha_inicio = null;
                            vm.protocolo.fecha_fin = null;
                        }else{
                            if (typeof vm.protocolo.fecha_inicio === 'undefined' || vm.fecha_inicio === '' || vm.protocolo.fecha_inicio === null) {
                                toastr.error('Favor ingresar las fechas solicitadas', 'Error!', {
                                    timeOut: 2000,
                                    closeButton: true
                                });
                                return;
                            }
                            if (typeof vm.protocolo.fecha_fin === 'undefined' || vm.fecha_fin === '' || vm.fecha_fin === null) {
                                toastr.error('Favor ingresar las fechas solicitadas', 'Error!', {
                                    timeOut: 2000,
                                    closeButton: true
                                });
                                return;
                            }
                        }

                        if (vm.correctiva && (vm.protocolo.causa_falla == '' || vm.protocolo.causa_falla == null)) {
                            toastr.error('Favor ingresar causa de falla', 'Error!', {
                                timeOut: 2000,
                                closeButton: true
                            });
                            return;
                        }

                        if (vm.correctiva && vm.protocolo.causa_falla.nombre == 'OTRO' && (vm.protocolo.otra_causa_falla == '' || vm.protocolo.otra_causa_falla == null)) {
                            toastr.error('Favor ingresar otra causa de falla', 'Error!', {
                                timeOut: 2000,
                                closeButton: true
                            });
                            return;
                        }
                        if (typeof vm.protocolo.segregacion === 'undefined' || vm.protocolo.segregacion === '') {
                            toastr.error('Favor ingresar si la orden de trabajo posee segregación', 'Error!', {
                                timeOut: 2000,
                                closeButton: true
                            });
                            return;
                        }



                        if (vm.protocolo.segregacion === 'si' && (typeof vm.protocolo.tipo_segregacion === 'undefined' || typeof vm.protocolo.tipo_segregacion === null)) {
                            toastr.error('Favor ingresar el tipo de segregación', 'Error!', {
                                timeOut: 2000,
                                closeButton: true
                            });
                            return;

                        } else {
                            if (vm.protocolo.segregacion === 'no') {
                                vm.protocolo.tipo_segregacion = null;
                            }
                        }

                      
                        let data = {
                            usuario: info.get('nombre') + ' ' + info.get('apellido'),
                            ott: {
                                _id: ott
                            },
                            
                            protocolo: vm.protocolo,
                            observacion: vm.observacion,
                            proyecto: vm.proyecto,
                            correctiva: vm.correctiva,
                            remoto: vm.remoto,
                            work_on_ground: vm.work_on_ground
                        };
                        modal.close(data);
                        console.log(vm.remoto)
                        console.log(vm.work_on_ground)
                    }
                },
                controllerAs: 'ctr',
                size: 'md',
                resolve: {
                    ottService: function () {
                        return ottService;
                    },
                    causaFallaCorrectivaService: function () {
                        return causaFallaCorrectivaService;
                    },
                    isTecnico: function () {
                        return isTecnico;
                    }

                }

            });

            modal.result.then((resp_in) => {

                if (resp_in) {

                    let data = {
                        usuario: resp_in.usuario,
                        "ott": resp_in.ott,
                        protocolo: resp_in.protocolo,
                        proyecto: resp_in.proyecto,
                        remoto: resp_in.remoto,
                        work_on_ground: resp_in.work_on_ground
                    };

                    ottService.guardarTareas(data)
                        .then((respTarea) => {
                            if (!resp_in.correctiva) {
                                let observacion = [{
                                    text: "[Tarea] : " + resp_in.observacion,
                                    usuario: resp_in.usuario,
                                    fecha: new Date(),
                                    "ott": resp_in.ott
                                }];
                                ottService.agregarObservacion(observacion)
                                    .then((resp) => {
                                        if (resp_in.flag) {
                                            this.cerrarOtt(ottService);
                                        } else {
                                            self.ott.observaciones = resp.data.observaciones;
                                            // self.location.path('/ott/');
                                            //window.location.reload();
                                            this.location.path('/ott/');
                                        }
                                    });
                            }
                        });

                }
            }, (exit) => {
                console.log('modal close');
            });
        } else {
            toastr.error('Favor revisar que toda la información fue ingresada', 'Error!', {
                timeOut: 2000,
                closeButton: true
            });
        }
    };

    handleDisplayFilters() {
        this.scope.displayFilters = !this.scope.displayFilters;
    }

    descargarArchivo(ottService, fileName) {
        var url = window.location;
        var urlNew = this.baseUrl + '/api/ott/descargarArchivo/' + this.scope.ott._id + '/' + fileName + '?token=' + localStorage.getItem('token');
        window.open(urlNew, '_blank', 'location=yes,height=570,width=520,scrollbars=yes,status=yes');
    }

    reagendar(ottService, toastr) {
        var self = this.scope;
        let templateModal = `
			<div class="modal-content">
				<div class="modal-header">
					<h4 style="text-align:center;" class="modal-title">Reagendar</h4>
				</div>
				<div class="modal-body">
					<div class="form-horizontal form-label-left">
                        <div class="row">
                            <div class="col-sm-3">				
                                <label class="control-label col-md-7 col-sm-4 col-xs-12">Jornada
                                </label>
                            </div>
                            <div class="col-md-6 col-sm-6 col-xs-12">
                                <div id="type" class="btn-group" data-toggle="buttons">
                                    <label class="btn "
                                        ng-class="{'btn-default': ctr.ott.jornada != 'diurna', 'btn-primary': ctr.ott.jornada == 'diurna'}"
                                        data-toggle-class="btn-primary" data-toggle-passive-class="btn-default">
                                        <input type="radio" ng-model="ctr.ott.jornada" value="diurna"> &nbsp; Diurna &nbsp;
                                    </label>
                                    <label class="btn btn-default"
                                        ng-class="{'btn-default': ctr.ott.jornada != 'nocturna', 'btn-primary': ctr.ott.jornada == 'nocturna'}"
                                        data-toggle-class="btn-primary" data-toggle-passive-class="btn-default">
                                        <input type="radio" ng-model="ctr.ott.jornada" value="nocturna"> &nbsp; Nocturna &nbsp;
                                    </label>
                                </div>
                                <br>
                                <label ng-show="marcaForm.$submitted && ctr.ott.jornada == null"
                                    class="control-label has-error validationMessage">* Requerido</label>
                            </div>	        
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-md-3 col-sm-3">
                                <label class="control-label col-md-3 col-sm-3 col-xs-12" for="first-name">Fecha:
                                </label>
                            </div>
                            <div class="col-md-6 col-sm-6 col-xs-12">
                                <div class="form-control" required
                                    ng-model="ctr.fecha_inicio"
                                    format="DD-MM-YYYY"
                                    moment-picker="ctr.aux.fecha_ott">
                                    {{ctr.aux.fecha_ott}}
                                </div>
                            </div>
                        </div>
                        <br>
                        <div class="row">			
                            <div class="col-sm-3">				
                                <label class="control-label col-md-7 col-sm-4 col-xs-12">Teams
                                </label>
                            </div>	
                            </label>
                            <div class="col-md-6 col-sm-6 col-xs-12">
                                <select class="form-control"
                                    ng-model="ctr.aux.team_final"
                                    ng-options="team as team.nombre for team in ctr.aux.teams | orderBy:'nombre' track by team._id">
                                </select>
                            </div>
                        </div>
                        <div class="row">			
                            <div class="col-sm-3">				
                                <label class="control-label col-md-7 col-sm-4 col-xs-12">Observaciones
                                </label>
                            </div>	
                            </label>
                            <div class="col-md-6 col-sm-6 col-xs-12">
                                <textarea ng-model="ctr.observacion" 
                                    style="width:100%;"
                                    class="resizable_textarea form-control"
                                    placeholder="Ingrese Observación"
                                    required
                                >
                                </textarea>
                            </div>
                        </div>
					</div>
			    </div>

                <div class="modal-footer">
					<div class="btn btn-success pull-right" ng-click="ctr.save()">Guardar</div>
			    </div>
			</div>
		`;
        let modal = this.modal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            template: templateModal,
            controller: function (ott, teams) {
                var vm = this;
                vm.fecha_inicio = null;
                vm.ott = ott;
                vm.aux = {
                    teams: teams,
                    team_final: vm.ott.calendario.equipo,
                    fecha_ott: vm.ott.fecha_agendada
                };

                this.save = () => {

                    if (typeof vm.observacion === 'undefined' || vm.observacion.trim() === '') {
                        toastr.error('Favor ingresar una observación', 'Error!', {
                            timeOut: 2000,
                            closeButton: true
                        });
                        return;
                    }

                    let data = {
                        _id: ott._id,
                        fecha_inicio: vm.fecha_inicio,
                        team_final: vm.aux.team_final,
                        jornada: vm.ott.jornada,
                        observacion: vm.observacion,
                        fecha_original: vm.ott.fecha_agendada
                    }
                    modal.close(data);
                }
            },
            controllerAs: 'ctr',
            size: 'md',
            resolve: {
                ottService: function () {
                    return ottService;
                },
                ott: function () {
                    return self.ott;
                },
                teams: function () {
                    return self.aux.teams;
                }
            }
        });

        modal.result.then((resp_in) => {

            if (resp_in) {
                ottService.reagendar(resp_in)
                    .then((respTarea) => {
                        window.location.reload();
                    });
            }
        }, (exit) => {
            console.log('modal close');
        });

    }

    eliminar(ottService) {
        var self = this.scope;
        let templateModal = `
			<div class="modal-content">
				<div class="modal-header">
					<h4 style="text-align:center;" class="modal-title">Eliminar OTT</h4>
				</div>
				<div class="modal-body">
					<div class="form-horizontal form-label-left">
                        <div class="row">
                            <div class="col-md-12 col-sm-12">				
                                ¿Esta seguro que quiere eliminar esta OTT?
                            </div>
                            	        
                        </div>
					</div>
			    </div>
			    <div class="modal-footer">
					<div class="btn btn-danger pull-right" ng-click="ctr.delete()">Eliminar</div>
			    </div>
			</div>
		`;
        let modal = this.modal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            template: templateModal,
            controller: function (ott) {
                var vm = this;

                this.delete = () => {
                    let data = {
                        _id: ott._id,
                    }
                    modal.close(data);
                }
            },
            controllerAs: 'ctr',
            size: 'sm',
            resolve: {
                ottService: function () {
                    return ottService;
                },
                ott: function () {
                    return self.ott;
                }
            }
        });

        modal.result.then((resp_in) => {

            if (resp_in) {
                ottService.delete(resp_in)
                    .then((resp) => {
                        this.location.path('/ott');
                    }, (err) => {
                        this.toastr.error(err.data.response, "Error", {
                            timeOut: 2000,
                            closeButton: true
                        });
                    });
            }
        })

    }

    descargarPdfLapiz(ottService) {

        let data = {
            _id: this.scope.ott._id
        }

        ottService.pdfLapiz(data)
            .then((resp) => {
                var urlNew = this.baseUrl + '/api/ott/pdf/' + resp.data.nombre + '?token=' + localStorage.getItem('token');
                window.open(urlNew);
            });
    }

    filterPDF(ottService, clientesService, proyectosService, estadosService, prioridadesService, columnasService, filter) {


        var self = this.scope;
        this.scope.nombre = "Descargas a PDF";
        this.scope.getUbicacion = this.getUbicacion.bind(this);
        this.scope.getTipo = this.getTipo.bind(this);
        this.scope.currentPage = 1;
        this.scope.totalItems = 0;
        this.sortType = null;
        this.sortReverse = true;
        this.scope.aux = {
            cliente: {},
            clientes: [],
            proyecto: {},
            proyectos: []
        };

        clientesService.getAll()
            .then((resp) => {
                let data = resp.data.message.map((el) => {
                    el.nombre_interno = "proyecto.cliente._id";
                    return el;
                });
                this.scope.aux.clientes = data;
            });

        this.scope.$watch('aux.cliente', (nuevo) => {

            if (nuevo) {
                let filter = {
                    "cliente._id": nuevo._id
                };
                filter = JSON.stringify(filter);
                proyectosService.getAll({ string: filter })
                    .then((resp) => {
                        let data = resp.data.message.map((el) => {
                            el.nombre_interno = "proyecto";
                            return el;
                        });
                        this.scope.aux.proyectos = data;
                        this.scope.columnas = columnasService.getColumnasOtt(nuevo.abreviacion);
                        if (data.length == 1) {
                            this.scope.aux.proyecto = data[0];
                        }
                    });
            } else {
                this.scope.aux.proyectos = [];
                this.scope.aux.proyecto = null;
            }
        });

        this.scope.$watch('aux.proyecto', (nuevo) => {

            if (nuevo) {
                let filter = {
                    grupo: 'ott',
                    proyecto: nuevo._id
                };

                estadosService.getAll(filter)
                    .then((resp) => {
                        let data = resp.data.message.map((el) => {
                            el.nombre_interno = "estado._id";
                            return el;
                        });
                        this.scope.aux.estados = data;
                    });
            } else {
                this.scope.aux.proyectos = [];
            }
        });



        prioridadesService.getAll()
            .then((resp) => {
                let data = resp.data.message.map((el) => {
                    el.nombre_interno = "prioridad._id";
                    return el;
                });
                this.scope.aux.prioridades = data;
            });


        this.scope.aux = {
            filtros: {
                "estado.index": {
                    $ne: 1
                }
            }
        };

        filter = JSON.stringify(filter);

        ottService.getAllPdfFilter(filter).then((resp, err) => {
            if (!err) {
                this.scope.totalItems = resp.data.message.total;
                this.scope.currentPage = resp.data.message.page;
                this.scope.otts = resp.data.message.docs;
            }
        });

        var ar_watch = ['aux.cliente', 'aux.proyecto', 'aux.estado', 'aux.prioridad', 'aux.tipo', 'aux.desde', 'aux.hasta'];

        this.scope.$watchGroup(ar_watch, (nuevo) => {

            let filtro = {};



            for (var el in nuevo) {
                let element = nuevo[el];

                if (element) {
                    if (element._id) {
                        filtro[element.nombre_interno] = element._id;
                    } else if (element === 'correctiva') {
                        filtro['preventiva'] = true;
                    } else if (element === 'preventiva') {
                        filtro['preventiva'] = false;
                    } else {
                        if (el == 5 && typeof nuevo[6] === 'undefined') {
                            var timezone = self.desde._d.getTimezoneOffset();
                            filtro['fecha_agendada'] = { "$gte": self.desde._d.getTime() - (timezone * 60 * 1000) }
                        } else if (el == 6 && typeof nuevo[5] === 'undefined') {
                            var timezone = self.hasta._d.getTimezoneOffset();
                            filtro['fecha_agendada'] = { "$lt": (self.hasta._d.getTime() + 86400000) - (timezone * 60 * 1000) }
                        } else if (el == 5 && typeof nuevo[6] !== 'undefined') {
                            var timezone = self.desde._d.getTimezoneOffset();
                            filtro['fecha_agendada'] = { "$gte": self.desde._d.getTime() - (timezone * 60 * 1000), "$lt": (self.hasta._d.getTime() + 86400000) - (timezone * 60 * 1000) }
                        } else {
                            filtro[element.tipo_p] = element.valor;
                        }
                    }
                }
            }

            if (typeof filtro['estado._id'] === 'undefined') {
                filtro["estado.index"] = {
                    $ne: 1
                };
            }

            if (typeof filtro['proyecto'] !== 'undefined') {
                delete filtro['proyecto.cliente._id'];
            }

            this.scope.aux.query = filtro;
            filtro = JSON.stringify(filtro);
            ottService.getAllPdfFilter(filtro)
                .then((resp, err) => {
                    if (!err) {
                        this.scope.otts = [];
                        this.scope.totalItems = resp.data.message.total;
                        this.scope.currentPage = resp.data.message.page;
                        this.scope.otts = resp.data.message.docs;
                        this.scope.otts.forEach(function (orden) {
                            if (typeof orden.proyecto.no_requeridos !== 'undefined' &&
                                typeof orden.proyecto.no_requeridos.ott !== 'undefined') {
                                if (orden.proyecto.no_requeridos.ott.indexOf('avance') > -1) {
                                    self.showColumnAvance = false;
                                }
                                if (orden.proyecto.no_requeridos.ott.indexOf('equipo') > -1) {
                                    self.showColumnEquipo = false;
                                }
                                if (orden.proyecto.cliente.abreviacion.toString() == "ACSA") {
                                    self.showColumnGlpi = true;
                                }
                            }
                        });
                    } else {
                        console.log(err);
                    }
                });
        });

        self.limpiarFiltros = () => {
            self.desde = null;
            self.aux.desde = null;
            self.hasta = null;
            self.aux.hasta = null;
            self.aux.cliente = null;
            self.aux.proyecto = null;
            self.aux.estado = null;
            self.aux.prioridad = null;
            self.aux.tipo = "";
        };

        self.changePage = (newPageNumber, oldPageNumber) => {

            let filtro = this.scope.aux.query;

            filtro.page = newPageNumber;
            filtro.limit = 10;
            // filtro = JSON.stringify(filtro);            
            this.scope.aux.query = filtro;
            ottService.getAllPdfFilter(filtro)
                .then((resp, err) => {
                    if (!err) {
                        this.scope.otts = [];
                        this.scope.totalItems = resp.data.message.total;
                        this.scope.currentPage = resp.data.message.page;
                        this.scope.otts = resp.data.message.docs;
                        this.scope.otts.forEach(function (orden) {
                            if (typeof orden.proyecto.no_requeridos !== 'undefined' &&
                                typeof orden.proyecto.no_requeridos.ott !== 'undefined') {
                                if (orden.proyecto.no_requeridos.ott.indexOf('avance') > -1) {
                                    self.showColumnAvance = false;
                                }
                                if (orden.proyecto.no_requeridos.ott.indexOf('equipo') > -1) {
                                    self.showColumnEquipo = false;
                                }
                                if (orden.proyecto.cliente.abreviacion.toString() == "ACSA") {
                                    self.showColumnGlpi = true;
                                }
                            }
                        });
                    } else {
                        console.log(err);
                    }
                });
        }

        self.orderBy = (sortType) => {
            self.sortType = sortType;
            self.sortReverse = !self.sortReverse;
            let filtro = this.scope.aux.query;
            filtro.sort = {};
            filtro.sort[self.sortType] = (self.sortReverse) ? 1 : -1;
            ottService.getAllPdfFilter(filtro)
                .then((resp, err) => {
                    if (!err) {
                        this.scope.otts = [];
                        this.scope.totalItems = resp.data.message.total;
                        this.scope.currentPage = resp.data.message.page;
                        this.scope.otts = resp.data.message.docs;
                        this.scope.otts.forEach(function (orden) {
                            if (typeof orden.proyecto.no_requeridos !== 'undefined' &&
                                typeof orden.proyecto.no_requeridos.ott !== 'undefined') {
                                if (orden.proyecto.no_requeridos.ott.indexOf('avance') > -1) {
                                    self.showColumnAvance = false;
                                }
                                if (orden.proyecto.no_requeridos.ott.indexOf('equipo') > -1) {
                                    self.showColumnEquipo = false;
                                }
                                if (orden.proyecto.cliente.abreviacion.toString() == "ACSA") {
                                    self.showColumnGlpi = true;
                                }
                            }
                        });
                    } else {
                        console.log(err);
                    }
                });
        }
    }

    descargarPdfLapizMasivo() {

        let info = this.scope.aux.query || this.scope.aux.filtros;


        let aux = JSON.parse(JSON.stringify(info));

        // var urlNew = this.baseUrl + '/api/ott/get-link-pdf' + '?string=' + JSON.stringify(aux);
        // window.open(urlNew);
        this.ottser.getLinkPDF(aux).then((resp, err) => {
            if (err) {
                this.toastr.error(err, 'Error!', {
                    timeOut: 2000,
                    closeButton: true
                });
            } else {
                this.toastr.success('Peticion realizada correctamente cuando este listo recibiras un link en tu correo!', 'Success!', {
                    timeOut: 2000,
                    closeButton: true
                });
            }
        })
    }

    carga(Upload) {
        this.scope.titulo = "Carga OTT";

        // this.textFiles = $files;
         
        this.scope.upFileText = ($files) => {
            console.log("upFileText");
            // if($files.length > 10) return false;
            this.scope.textFiles = $files;
        };

        this.scope.fileUpload = () => {
            console.log("fileUpload");
            Upload.upload({
                url: this.baseUrl + '/api/ott/carga',
                data: {
                    filess: this.scope.textFiles
                },
                filess: this.scope.textFiles
            }).then((res, err) => {
                if (res.data.success == 'ok') {
                    self.ott.textFiles = res.data.fileList;
                    this.toastr.success('Archivo agregado correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                } else {
                    this.toastr.error(res.data.message, 'Error!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./app/js/controllers/ott/ott.js